import React, { Fragment } from "react";
import {
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  BlockFooter,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  ListButton,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Toggle,
  Preloader,
  Input,
  LoginScreen,
  LoginScreenTitle,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
} from "framework7-react";
import { PaystackButton } from "react-paystack";
import moment from "moment";
import cryptoRandomString from "crypto-random-string";
import { getDistance, convertDistance } from "geolib";

import { PrimaryLogo, OrdersSvg } from "../components/crumbs";
import NetworkError from "../components/networkError";

import { connect } from "react-redux";
import { compose } from "redux";
import { firestoreConnect } from "../HOCs";
import { Collections, Doc } from "../utils/_classes";
import {
  generateId,
  placeOrder,
  toast,
  totalProductPrice,
  deliveryCharge,
  reduceProductStock,
  transact,
  totalProductAndDeliveryCharge,
  userQualifiedForEasychawDiscount,
  calcEasychawDiscount,
  handleErrors,
  preparationTimeComputed,
  serviceCharge,
  cummulativeTotalProductPrice,
  checkFreeDelivery,
  reverseGeocoding,
  checksingleProductAvailableForOrder,
  checkProductsAvailabilityForOrder,
  isAllowed,
  chargeCard,
  isMerchantOpen,
  getCurrentTime,
} from "../utils/_helpers";
import { CART } from "../store/actions/cart";

// check if staging or prod
import { PAYSTACK_PUBLIC_KEY } from "../config/envConfig";

class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popupOpened: false,
      popupDataChanged: true,
      cart: this.props.cart,

      currentDateTime: null,
      dateTimeInterval: null,

      postDatedOrders: {},
      expectedDeliveryTime: {},
      relId: generateId(7),
      reference: generateId(15),

      easychawWallet: false,

      pay: true,
      useBonus: false,
      bonus: 0,

      //supplementary login
      loginScreenOpened: false,
      email: "",
      password: "",
      fullName: "",
      phoneNumber: "",
      signInButton: "Sign In",
      registerButton: "Sign Up",
      register: false,

      //saved card
      savedCard: {
        opened: false,
        authorization_code: "",
        email: "",
        last4: "",
      },
    };
  }

  render() {
    return (
      <Page
        id="cart-page"
        onPageAfterIn={this.onPageAfterIn.bind(this)}
        style={{ backgroundColor: "#fbfbfb" }}
      >
        {/* Top Navbar */}
        <Navbar backLink="Back">
          <NavTitle sliding>
            <PrimaryLogo size="132" />
          </NavTitle>
        </Navbar>

        {!navigator.onLine ? (
          <NetworkError />
        ) : (
          <>
            {/* Page content */}
            <Row noGap>
              {this.props.auth.isEmpty && (
                <Col width="100">
                  {/* [Card - 1] Authentication Card */}
                  <Block className="pattern-banner bg-color-theme">
                    <Card style={{ width: "100%", margin: 0 }}>
                      <CardHeader>
                        <h3>Experience Easychaw&#8482;</h3>
                        <Button
                          round
                          fill
                          tabLink="#view-map"
                          loginScreenOpen=".user-login-screen"
                        >
                          Log On
                        </Button>
                      </CardHeader>
                    </Card>
                  </Block>
                </Col>
              )}

              {this.props.cart !== null && this.props.cart.length > 0 && (
                <Col width="100" className="large-55 padding-bottom">
                  {/* [Card - 2] Cart Items */}
                  <Card style={{ marginBottom: "40px" }}>
                    <CardHeader
                      className="no-border bg-color-cultured bg-image-pattern white-overlay"
                      style={{
                        backgroundSize:
                          parseInt(window.innerWidth) < 700 ? "50%" : "30%",
                        height: "200px",
                      }}
                    >
                      <img
                        src="static/cart.svg"
                        style={{ margin: "auto", width: "200px", zIndex: 1 }}
                      />
                    </CardHeader>
                    <CardFooter>
                      <strong alt="cart quantity">
                        Cart Items{" "}
                        {this.props.cart === null
                          ? "(0)"
                          : `(${this.props.cart
                              .map((cartObject) =>
                                cartObject.packages
                                  .map((product) => product.count)
                                  .reduce((a, b) => Number(a) + Number(b), 0),
                              )
                              .reduce((a, b) => Number(a) + Number(b), 0)})`}
                      </strong>
                      <Button outline className="back">
                        <Icon f7="cart_badge_plus"></Icon>&nbsp;&nbsp;&nbsp;Add
                        Items
                      </Button>
                    </CardFooter>
                  </Card>

                  {this.props.data.loading &&
                  !this.props.data.products &&
                  !this.props.ordered.products &&
                  !this.props.data.merchant ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : (
                    this.props.cart.map((cartObject) => (
                      <Fragment key={cartObject.merchantId}>
                        <Card
                          inner
                          accordionList
                          className={
                            Object.keys(this.state.postDatedOrders).length >
                              0 &&
                            !this.isMerchantWithinRange(
                              cartObject.merchantId,
                              this.props.data.merchants[cartObject.merchantId]
                                .businessProfile.geoLoc,
                            )
                              ? "rangeout"
                              : Object.keys(this.state.postDatedOrders).length >
                                  0 &&
                                !isMerchantOpen(
                                  this.state.currentDateTime,
                                  this.props.data.merchants?.[
                                    cartObject.merchantId
                                  ]?.businessProfile.operationDays,
                                  this.props.data.merchants?.[
                                    cartObject.merchantId
                                  ]?.businessProfile.operationTimes,
                                  this.props.data.merchants?.[
                                    cartObject.merchantId
                                  ]?.businessProfile.operationStartTime,
                                  this.props.data.merchants?.[
                                    cartObject.merchantId
                                  ]?.businessProfile.operationCloseTime,
                                )
                              ? "merchant-closed"
                              : ""
                          }
                          style={{ marginTop: 20 }}
                        >
                          <AccordionItem opened>
                            <CardHeader>
                              {this.props.data.merchants &&
                                this.props.data.merchants[
                                  cartObject.merchantId
                                ] &&
                                this.props.data.merchants[cartObject.merchantId]
                                  .businessProfile.name}
                              <AccordionToggle>
                                <Button
                                  outline
                                  iconF7="arrowtriangle_down_fill"
                                ></Button>
                              </AccordionToggle>
                            </CardHeader>

                            <AccordionContent>
                              {/* Products */}
                              <CardContent padding={false}>
                                <List>
                                  {cartObject.packages.map((p) =>
                                    this.props.data.products &&
                                    !this.props.data.products[p.productId] ? (
                                      <ListItem>
                                        <ListItemCell className="width-auto flex-shrink-0">
                                          <div className="text-align-center">
                                            <Preloader></Preloader>
                                          </div>
                                        </ListItemCell>
                                        <ListItemCell className="width-auto flex-shrink-0">
                                          {" "}
                                          <div className="text-align-center">
                                            <Preloader></Preloader>
                                          </div>
                                        </ListItemCell>
                                        <ListItemCell className="width-auto flex-shrink-0">
                                          {" "}
                                          <div className="text-align-center">
                                            <Preloader></Preloader>
                                          </div>
                                        </ListItemCell>
                                      </ListItem>
                                    ) : (
                                      <ListItem
                                        key={p.productId}
                                        tooltip={
                                          this.props.data.products &&
                                          this.props.data.products[
                                            p.productId
                                          ] &&
                                          checksingleProductAvailableForOrder(
                                            p.productId,
                                            this.props.data.products,
                                          )
                                            ? this.conFirmQuantity(
                                                p,
                                                this.props.data.products,
                                              )
                                              ? ""
                                              : `Item above stocked. Please reduce quantity to ${
                                                  this.props.data.products[
                                                    p.productId
                                                  ].stocked
                                                }`
                                            : "Item unavailable. Please remove from cart"
                                        }
                                        className={
                                          this.props.data.products &&
                                          this.props.data.products[
                                            p.productId
                                          ] &&
                                          checksingleProductAvailableForOrder(
                                            p.productId,
                                            this.props.data.products,
                                          ) &&
                                          this.conFirmQuantity(
                                            p,
                                            this.props.data.products,
                                          )
                                            ? ""
                                            : "no-product"
                                        }
                                      >
                                        <ListItemCell className="width-auto flex-shrink-0">
                                          <span
                                            style={{ display: "inline-flex" }}
                                          >
                                            <Input
                                              type="number"
                                              className="cart-item-input"
                                              min="1"
                                              onBlur={(e) =>
                                                this.blurWithEmptyness(
                                                  e,
                                                  cartObject,
                                                  p,
                                                )
                                              }
                                              value={
                                                this.state.cart &&
                                                this.state.cart.length > 0 &&
                                                this.state.cart
                                                  .find(
                                                    (co) =>
                                                      co.merchantId ===
                                                      cartObject.merchantId,
                                                  )
                                                  .packages.find(
                                                    (co) =>
                                                      co.productId ===
                                                      p.productId,
                                                  ).count
                                              }
                                              onChange={(e) => {
                                                this.delayChangeCount(
                                                  e,
                                                  cartObject,
                                                  p,
                                                  this.changeCount.bind(this),
                                                );
                                              }}
                                            />
                                            &nbsp;&nbsp;x&nbsp;&nbsp;
                                          </span>
                                        </ListItemCell>
                                        <ListItemCell
                                          className="flex-shrink-3"
                                          style={{
                                            marginLeft: 0,
                                          }}
                                        >
                                          <div className="row">
                                            <p className="col">
                                              {this.props.data.products &&
                                                this.props.data.products[
                                                  p.productId
                                                ].name}
                                            </p>
                                          </div>
                                        </ListItemCell>
                                        <ListItemCell className="width-auto flex-shrink-0">
                                          <h6>
                                            {new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "NGN",
                                            }).format(
                                              Math.ceil(
                                                Number(p.count) *
                                                  totalProductPrice(
                                                    this.props.data.products &&
                                                      this.props.data.products[
                                                        p.productId
                                                      ].price,
                                                    this.props.data.products &&
                                                      this.props.data.products[
                                                        p.productId
                                                      ].discount,
                                                  ),
                                              ),
                                            )}
                                          </h6>
                                        </ListItemCell>
                                        <ListItemCell className="width-auto flex-shrink-0">
                                          <Button
                                            iconF7="trash"
                                            className="trash"
                                            onClick={() =>
                                              this.$f7.dialog.confirm(
                                                "This item will be removed from your cart.",
                                                "Cart Items",
                                                () =>
                                                  this.removeCartItem(
                                                    cartObject.merchantId,
                                                    p.productId,
                                                  ),
                                              )
                                            }
                                          ></Button>
                                        </ListItemCell>
                                      </ListItem>
                                    ),
                                  )}
                                </List>
                              </CardContent>

                              {/* Delivery Details */}
                              <CardHeader
                                style={{
                                  backgroundColor: "rgba(200,200,200,0.1)",
                                  padding: "16px",
                                }}
                              >
                                <strong>Delivery Details</strong>

                                {/* Hide button if product is for pick up */}

                                {this.props.data &&
                                this.props.data.products &&
                                !checkFreeDelivery(
                                  cartObject.packages,
                                  this.props.data.products,
                                ) ? (
                                  <Button
                                    className={
                                      this.state.postDatedOrders[
                                        cartObject.merchantId
                                      ] &&
                                      this.state.postDatedOrders[
                                        cartObject.merchantId
                                      ].editAddress
                                        ? "button-fill"
                                        : "button-outline"
                                    }
                                    onClick={() => {
                                      this.setState((prevState) => {
                                        return {
                                          ...prevState,
                                          postDatedOrders: {
                                            ...prevState.postDatedOrders,
                                            [cartObject.merchantId]: {
                                              ...prevState.postDatedOrders[
                                                cartObject.merchantId
                                              ],
                                              editAddress:
                                                !prevState.postDatedOrders[
                                                  cartObject.merchantId
                                                ].editAddress,
                                            },
                                          },
                                        };
                                      });
                                    }}
                                  >
                                    <Icon f7="map_pin_ellipse"></Icon>
                                    &nbsp;&nbsp;&nbsp;Edit Address
                                  </Button>
                                ) : null}
                              </CardHeader>

                              {/* Hide delivery details if product is for pick up */}
                              {this.props.data &&
                                this.props.data.products &&
                                (!checkFreeDelivery(
                                  cartObject.packages,
                                  this.props.data.products,
                                ) ? (
                                  <CardContent>
                                    <List>
                                      <ListItem>
                                        <p
                                          slot="title"
                                          style={{ whiteSpace: "pre-wrap" }}
                                        >
                                          Your order will arrive in{" "}
                                          <strong style={{ display: "block" }}>
                                            {this.props.data.products
                                              ? this.state.expectedDeliveryTime[
                                                  cartObject.merchantId
                                                ]?.time
                                                ? moment(
                                                    this.state
                                                      .expectedDeliveryTime[
                                                      cartObject.merchantId
                                                    ].time,
                                                  ).toNow(true)
                                                : preparationTimeComputed(
                                                    Math.max(
                                                      ...cartObject.packages.map(
                                                        (product) =>
                                                          this.props.data
                                                            .products[
                                                            product.productId
                                                          ].preparationTime,
                                                      ),
                                                    ) + 30,
                                                  )
                                              : null}{" "}
                                            -{" "}
                                            {this.props.data.products
                                              ? this.state.expectedDeliveryTime[
                                                  cartObject.merchantId
                                                ]?.time
                                                ? moment(
                                                    this.state
                                                      .expectedDeliveryTime[
                                                      cartObject.merchantId
                                                    ].time,
                                                  ).format("DD/MM/YYYY, hh:mma")
                                                : moment()
                                                    .add(
                                                      Math.max(
                                                        ...cartObject.packages.map(
                                                          (product) =>
                                                            this.props.data
                                                              .products[
                                                              product.productId
                                                            ].preparationTime,
                                                        ),
                                                      ) + 30,
                                                      "minutes",
                                                    )
                                                    .format(
                                                      "DD/MM/YYYY, hh:mma",
                                                    )
                                              : null}
                                          </strong>
                                        </p>
                                        <Icon f7="timer" slot="media" />
                                        <span
                                          slot="after"
                                          style={{
                                            fontSize: "12px",
                                            color: "#9E9E9E",
                                          }}
                                        >
                                          Estimated time
                                        </span>
                                      </ListItem>
                                      {/* expected Delivery Time */}
                                      {this.state.postDatedOrders?.[
                                        cartObject.merchantId
                                      ]?.postDated ? null : moment()
                                          .add(
                                            Math.max(
                                              ...cartObject.packages.map(
                                                (product) =>
                                                  this.props.data.products[
                                                    product.productId
                                                  ].preparationTime,
                                              ),
                                            ) + 30,
                                            "minutes",
                                          )
                                          .diff(moment(), "hours") < 23 ? (
                                        <ListInput
                                          key={"EDT-" + cartObject.merchantId}
                                          size={20}
                                          name="EDT"
                                          errorMessage={
                                            this.state.expectedDeliveryTime[
                                              cartObject.merchantId
                                            ]?.errorMessage
                                          }
                                          errorMessageForce={
                                            this.state.expectedDeliveryTime[
                                              cartObject.merchantId
                                            ]?.error
                                          }
                                          type="datepicker"
                                          placeholder="Select date and time"
                                          readonly
                                          calendarParams={{
                                            disabled: (date) => {
                                              moment(date).isBefore(moment())
                                                ? true
                                                : false;
                                            },
                                            // locale: "en-NG",
                                            dateFormat: "dd/mm/yyyy, hh::mma",
                                            // dateFormat: {
                                            //   month: "numeric",
                                            //   day: "numeric",
                                            //   year: "numeric",
                                            //   hour: "numeric",
                                            //   minute: "numeric",
                                            // },
                                            timePicker: true,
                                            timePickerFormat: {
                                              hour: "numeric",
                                              minute: "numeric",
                                            },
                                          }}
                                          onCalendarChange={(value) => {
                                            if (
                                              moment(value[0]).isBefore(
                                                moment().add(
                                                  Math.max(
                                                    ...cartObject.packages.map(
                                                      (product) =>
                                                        this.props.data
                                                          .products[
                                                          product.productId
                                                        ].preparationTime,
                                                    ),
                                                  ) + 30,
                                                  "minutes",
                                                ),
                                              )
                                            ) {
                                              this.setState({
                                                ...this.state,
                                                expectedDeliveryTime: {
                                                  ...this.state
                                                    .expectedDeliveryTime,
                                                  [cartObject.merchantId]: {
                                                    ...this.state
                                                      .expectedDeliveryTime[
                                                      cartObject.merchantId
                                                    ],
                                                    error: true,
                                                    errorMessage:
                                                      "Cannot pick a time below estimated delivery time",
                                                    time: null,
                                                  },
                                                },
                                              });
                                            } else {
                                              this.setState({
                                                ...this.state,
                                                expectedDeliveryTime: {
                                                  ...this.state
                                                    .expectedDeliveryTime,
                                                  [cartObject.merchantId]: {
                                                    ...this.state
                                                      .expectedDeliveryTime[
                                                      cartObject.merchantId
                                                    ],
                                                    time: value[0],
                                                    error: false,
                                                    errorMessage: "",
                                                  },
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <Icon f7="stopwatch" slot="media" />
                                          <span
                                            slot="label"
                                            style={{
                                              color: "red",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Please input order delivery time
                                          </span>
                                        </ListInput>
                                      ) : (
                                        <ListItem>
                                          <p
                                            slot="title"
                                            style={{ whiteSpace: "pre-wrap" }}
                                          >
                                            This order must be a postdated
                                            order. Please enable postdated order
                                            button below
                                          </p>
                                          <Icon
                                            f7="info_circle"
                                            slot="media"
                                            color="red"
                                          />
                                          {/* <span
                                          slot="after"
                                          style={{
                                            fontSize: "12px",
                                            color: "#9E9E9E",
                                          }}
                                        >
                                          Alert
                                        </span> */}
                                        </ListItem>
                                      )}

                                      {this.state.postDatedOrders &&
                                        this.state.postDatedOrders[
                                          cartObject.merchantId
                                        ] && (
                                          <ListInput
                                            label={`Delivery Address`}
                                            type="text"
                                            placeholder="Please enter a delivey address"
                                            info="Click Edit Address to modify"
                                            required
                                            onBlur={(e) => {
                                              this.setState({
                                                ...this.state,
                                                pay: false,
                                              });
                                              if (
                                                e.target.value.trim() === ""
                                              ) {
                                                return toast(this.$f7.toast, {
                                                  text: `Please enter a valid address`,
                                                  position: "bottom",
                                                  horizontalPosition: "center",
                                                  closeButton: true,
                                                  cssClass: "custom-toast",
                                                  closeTimeout: 4000,
                                                });
                                              }
                                              // this.typingAddress(
                                              //   e.target.value,
                                              //   cartObject.merchantId
                                              // );
                                            }}
                                            disabled={
                                              !this.state.postDatedOrders[
                                                cartObject.merchantId
                                              ].editAddress
                                            }
                                            style={
                                              this.state.postDatedOrders[
                                                cartObject.merchantId
                                              ].editAddress
                                                ? {
                                                    animation:
                                                      "glow 2s ease 0s 1",
                                                  }
                                                : {}
                                            }
                                            validate
                                            id={
                                              "edit-address-" +
                                              cartObject.merchantId
                                            }
                                            value={
                                              this.state.postDatedOrders[
                                                cartObject.merchantId
                                              ].deliveryAddress
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                ...this.state,
                                                pay: false,
                                                postDatedOrders: {
                                                  ...this.state.postDatedOrders,
                                                  [cartObject.merchantId]: {
                                                    ...this.state
                                                      .postDatedOrders[
                                                      cartObject.merchantId
                                                    ],
                                                    deliveryAddress:
                                                      e.target.value,
                                                  },
                                                },
                                              })
                                            }
                                          >
                                            <Icon f7="placemark" slot="media" />
                                          </ListInput>
                                        )}
                                    </List>
                                  </CardContent>
                                ) : (
                                  <CardContent padding={false}>
                                    <Block
                                      className="pab"
                                      style={{ width: "100%" }}
                                    >
                                      <Row noGap>
                                        <Col width="10">
                                          <Icon f7="exclamationmark_triangle"></Icon>
                                        </Col>
                                        <Col width="90">
                                          Product is for pick up only.
                                        </Col>
                                      </Row>
                                    </Block>
                                  </CardContent>
                                ))}

                              {/* Post date order */}
                              <CardHeader
                                style={{
                                  backgroundColor: "rgba(200,200,200,0.1)",
                                  padding: "25.5px 16px",
                                }}
                              >
                                Post Date Order
                                <Toggle
                                  color="green"
                                  onToggleChange={(e) =>
                                    this.setState({
                                      ...this.state,
                                      postDatedOrders: {
                                        ...this.state.postDatedOrders,
                                        [cartObject.merchantId]: {
                                          ...this.state.postDatedOrders[
                                            cartObject.merchantId
                                          ],
                                          postDated: e,
                                        },
                                      },
                                    })
                                  }
                                  defaultChecked={false}
                                ></Toggle>
                              </CardHeader>
                              {this.state.postDatedOrders[
                                cartObject.merchantId
                              ] &&
                              this.state.postDatedOrders[cartObject.merchantId]
                                .postDated ? (
                                <CardContent>
                                  <List>
                                    {/* postDatedDate */}
                                    <ListInput
                                      key={"date-" + cartObject.merchantId}
                                      label={
                                        this.props.data &&
                                        this.props.data.products &&
                                        !checkFreeDelivery(
                                          cartObject.packages,
                                          this.props.data.products,
                                        )
                                          ? "When do you need meal to be delivered?"
                                          : "When would you prefer to pick up meal?"
                                      }
                                      type="datepicker"
                                      placeholder="Select date and time"
                                      readonly
                                      calendarParams={{
                                        disabled: (date) => {
                                          if (
                                            moment(date).isAfter(
                                              moment().add(
                                                Math.max(
                                                  ...cartObject.packages.map(
                                                    (product) =>
                                                      this.props.data.products[
                                                        product.productId
                                                      ].preparationTime,
                                                  ),
                                                ) + 30,
                                                "minutes",
                                              ),
                                            )
                                          ) {
                                            return false;
                                          }

                                          return true;
                                        },
                                        dateFormat: {
                                          month: "numeric",
                                          day: "numeric",
                                          year: "numeric",
                                          hour: "numeric",
                                          minute: "numeric",
                                        },
                                        timePicker: true,
                                      }}
                                      onCalendarChange={(value) => {
                                        this.setState({
                                          ...this.state,
                                          postDatedOrders: {
                                            ...this.state.postDatedOrders,
                                            [cartObject.merchantId]: {
                                              ...this.state.postDatedOrders[
                                                cartObject.merchantId
                                              ],
                                              postDatedDate: value[0],
                                            },
                                          },
                                          expectedDeliveryTime: {
                                            ...this.state.expectedDeliveryTime,
                                            [cartObject.merchantId]: {
                                              ...this.state
                                                .expectedDeliveryTime[
                                                cartObject.merchantId
                                              ],
                                              time: value[0],
                                              error: false,
                                              errorMessage: "",
                                            },
                                          },
                                        });
                                      }}
                                    />

                                    {/* postDatedInstruction */}
                                    <ListInput
                                      key={
                                        "instruction-" + cartObject.merchantId
                                      }
                                      label="Additional Instructions"
                                      type="textarea"
                                      placeholder="Please leave a message"
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          postDatedOrders: {
                                            ...this.state.postDatedOrders,
                                            [cartObject.merchantId]: {
                                              ...this.state.postDatedOrders[
                                                cartObject.merchantId
                                              ],
                                              postDatedInstructions:
                                                e.target.value,
                                            },
                                          },
                                        })
                                      }
                                    ></ListInput>
                                  </List>
                                </CardContent>
                              ) : null}
                            </AccordionContent>
                          </AccordionItem>
                        </Card>
                      </Fragment>
                    ))
                  )}
                </Col>
              )}

              {!this.props.auth.isEmpty &&
                this.props.cart !== null &&
                this.props.data.merchants &&
                this.props.data.products &&
                this.props.ordered.products &&
                this.props.ordered.products.length > 0 &&
                this.props.ordered.merchants &&
                this.props.ordered.merchants.length > 0 &&
                Object.keys(this.state.postDatedOrders).length > 0 &&
                this.props.cart.length > 0 && (
                  <Col width="100" className="large-45 padding-bottom">
                    {/* [Card - 5] Invoice Details */}
                    <Card style={{ marginBottom: 20 }}>
                      <CardHeader>Invoice Details</CardHeader>
                      <CardContent>
                        <List noHairlinesMd>
                          <ListItem title="Items Total Amount">
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(
                                Math.ceil(
                                  +cummulativeTotalProductPrice(
                                    this.props.cart,
                                    this.props.data.products,
                                  ),
                                ),
                              )}
                            </small>
                            <Icon f7="creditcard" slot="media" />
                          </ListItem>
                          {this.props.cart
                            .map((cartObject) => {
                              if (
                                checkFreeDelivery(
                                  cartObject.packages,
                                  this.props.data.products,
                                )
                              ) {
                                return 0;
                              } else {
                                return deliveryCharge(
                                  this.props.data.merchants[
                                    cartObject.merchantId
                                  ].businessProfile.geoLoc,
                                  this.state.postDatedOrders[
                                    cartObject.merchantId
                                  ].geoLoc,
                                  {
                                    defaultDeliveryCharge:
                                      this.props.data.settings &&
                                      this.props.data.settings["easychaw"]
                                        ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                            cartObject,
                                          )?.deliveryCharge ||
                                            this.props.data.settings["easychaw"]
                                              .defaultDeliveryCharge) *
                                          this.checkDeliveryMeans(
                                            cartObject.packages,
                                          )
                                        : 500,
                                    perKmDeliveryCharge:
                                      this.props.data.settings &&
                                      this.props.data.settings["easychaw"]
                                        ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                            cartObject,
                                          )?.kmPerDeliveryCharge ||
                                            this.props.data.settings["easychaw"]
                                              .perKmDeliveryCharge) *
                                          this.checkDeliveryMeans(
                                            cartObject.packages,
                                          )
                                        : 50,
                                  },
                                  this.deliveryInclusive(cartObject.packages),
                                );
                              }
                            })
                            .reduce((acc, charge) => acc + charge, 0) ===
                          0 ? null : (
                            <ListItem title="Delivery Charge">
                              <small slot="after">
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  Math.ceil(
                                    this.props.cart
                                      .map((cartObject) => {
                                        if (
                                          checkFreeDelivery(
                                            cartObject.packages,
                                            this.props.data.products,
                                          )
                                        ) {
                                          return 0;
                                        } else {
                                          return deliveryCharge(
                                            this.props.data.merchants[
                                              cartObject.merchantId
                                            ].businessProfile.geoLoc,
                                            this.state.postDatedOrders[
                                              cartObject.merchantId
                                            ].geoLoc,
                                            {
                                              defaultDeliveryCharge:
                                                this.props.data.settings &&
                                                this.props.data.settings[
                                                  "easychaw"
                                                ]
                                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                      cartObject,
                                                    )?.deliveryCharge ||
                                                      this.props.data.settings[
                                                        "easychaw"
                                                      ].defaultDeliveryCharge) *
                                                    this.checkDeliveryMeans(
                                                      cartObject.packages,
                                                    )
                                                  : 500,
                                              perKmDeliveryCharge:
                                                this.props.data.settings &&
                                                this.props.data.settings[
                                                  "easychaw"
                                                ]
                                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                      cartObject,
                                                    )?.kmPerDeliveryCharge ||
                                                      this.props.data.settings[
                                                        "easychaw"
                                                      ].perKmDeliveryCharge) *
                                                    this.checkDeliveryMeans(
                                                      cartObject.packages,
                                                    )
                                                  : 50,
                                            },
                                            this.deliveryInclusive(
                                              cartObject.packages,
                                            ),
                                          );
                                        }
                                      })
                                      .reduce((acc, charge) => acc + charge, 0),
                                  ),
                                )}
                              </small>
                              <Icon f7="creditcard" slot="media" />
                            </ListItem>
                          )}

                          <ListItem
                            title="Service Charge &#x2139;"
                            tooltip="Service charge is only charged for card payments"
                          >
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(
                                Math.ceil(
                                  serviceCharge(
                                    this.props.cart,
                                    this.props.data.products,
                                    this.props.data.merchants,
                                    this.state.postDatedOrders,
                                    {
                                      percentageOrdersBelowAThousand:
                                        this.props.data.settings &&
                                        this.props.data.settings["easychaw"]
                                          ? this.props.data.settings["easychaw"]
                                              .percentageOrdersBelowAThousand
                                          : 2.55,
                                      percentageOrdersAboveAThousand:
                                        this.props.data.settings &&
                                        this.props.data.settings["easychaw"]
                                          ? this.props.data.settings["easychaw"]
                                              .percentageOrdersAboveAThousand
                                          : 3.95,
                                    },

                                    this.deliveryInclusive.bind(this),
                                    this.checkDeliveryMeans.bind(this),
                                    this.state.easychawWallet,
                                    this.props.data.settings?.["easychaw"],
                                  ),
                                ),
                              )}
                            </small>
                            <Icon f7="creditcard" slot="media" />
                          </ListItem>
                          {this.props.cart &&
                            this.props.data.products &&
                            userQualifiedForEasychawDiscount(
                              this.props.cart,
                              this.props.data.products,
                            ) && (
                              <ListItem
                                className="bg-color-cultured"
                                title="You qualified for Easychaw's bonus"
                              >
                                <Icon f7="gift" slot="media" />
                              </ListItem>
                            )}
                        </List>
                      </CardContent>
                      <CardFooter className="no-padding">
                        <Block style={{ width: "100%", margin: 0 }}>
                          <Row noGap>
                            <Col>
                              <strong>Total</strong>
                            </Col>
                            <Col style={{ textAlign: "right" }}>
                              <strong>
                                {this.props.cart === null
                                  ? new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(0)
                                  : // : this.props.cart
                                    this.props.data.products &&
                                    new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(
                                      Math.ceil(
                                        Number(
                                          totalProductAndDeliveryCharge(
                                            this.props.cart,
                                            this.props.data.products,
                                            this.props.data.merchants,
                                            this.state.postDatedOrders,
                                            this.deliveryInclusive.bind(this),
                                            this.checkDeliveryMeans.bind(this),
                                            this.applyBonus.bind(this),
                                            this.props.data.settings?.[
                                              "easychaw"
                                            ],
                                          ) +
                                            serviceCharge(
                                              this.props.cart,
                                              this.props.data.products,
                                              this.props.data.merchants,
                                              this.state.postDatedOrders,
                                              {
                                                percentageOrdersBelowAThousand:
                                                  this.props.data.settings &&
                                                  this.props.data.settings[
                                                    "easychaw"
                                                  ]
                                                    ? this.props.data.settings[
                                                        "easychaw"
                                                      ]
                                                        .percentageOrdersBelowAThousand
                                                    : 2.55,
                                                percentageOrdersAboveAThousand:
                                                  this.props.data.settings &&
                                                  this.props.data.settings[
                                                    "easychaw"
                                                  ]
                                                    ? this.props.data.settings[
                                                        "easychaw"
                                                      ]
                                                        .percentageOrdersAboveAThousand
                                                    : 3.95,
                                              },

                                              this.deliveryInclusive.bind(this),
                                              this.checkDeliveryMeans.bind(
                                                this,
                                              ),
                                              this.state.easychawWallet,
                                              this.props.data.settings?.[
                                                "easychaw"
                                              ],
                                            ),
                                        ),
                                      ),
                                    )}
                              </strong>
                            </Col>
                          </Row>
                        </Block>
                      </CardFooter>
                    </Card>

                    {/* [Card - 6] Apply Bonus */}
                    {!this.props.docs.wallets ||
                    (this.props.docs.wallets &&
                      this.props.docs.wallets[this.props.profile.walletId] &&
                      (this.props.docs.wallets[this.props.profile.walletId]
                        .ban ||
                        +this.props.docs.wallets[this.props.profile.walletId]
                          .bonuses < 100)) ||
                    (Object.keys(this.state.postDatedOrders).length > 0 &&
                      Object.keys(this.state.postDatedOrders)
                        .filter(
                          (key) =>
                            checkFreeDelivery(
                              this.state.cart.find(
                                (cartObject) => cartObject.merchantId === key,
                              ).packages,
                              this.props.data.products,
                            ) === false,
                        )
                        .find(
                          (key) =>
                            this.state.postDatedOrders[key].deliveryAddress ===
                            "",
                        )) ||
                    !this.state.pay ||
                    !checkProductsAvailabilityForOrder(
                      this.props.cart,
                      this.props.data.products,
                    ) ||
                    !this.confirmQuantities(
                      this.props.cart,
                      this.props.data.products,
                    ) ||
                    (Object.keys(this.state.postDatedOrders).length > 0 &&
                      this.isAnyMerchantOutOfRange()) ||
                    this.isMerchantClosed() ||
                    this.isExpectedDeliveryTimeError() ? null : (
                      <Card style={{ marginBottom: 20 }}>
                        <CardHeader>
                          <span>
                            <Icon f7="lock_shield" color="green"></Icon>
                            &nbsp;&nbsp;&nbsp;
                            {this.state.useBonus
                              ? "Bonus Applied"
                              : "Apply Bonus"}
                            {this.state.useBonus && (
                              <Icon
                                f7="checkmark_circle_fill"
                                color="green"
                              ></Icon>
                            )}
                          </span>
                        </CardHeader>

                        <CardContent>
                          <List>
                            <ListItem
                              title="Bonus Balance &#x2139;"
                              tooltip="Easily spend your bonus if upto NGN 100 and above"
                            >
                              <small slot="after">
                                {!this.props.profile.isEmpty &&
                                this.props.docs.wallets &&
                                this.props.docs.wallets[
                                  this.props.profile.walletId
                                ]
                                  ? new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(
                                      this.props.docs.wallets[
                                        this.props.profile.walletId
                                      ].bonuses,
                                    )
                                  : 0}
                              </small>
                              <Icon f7="gift" slot="media" />
                            </ListItem>
                          </List>
                        </CardContent>
                        {!this.state.useBonus && (
                          <CardFooter>
                            <Button
                              outline
                              style={{ width: "100%" }}
                              onClick={(e) => {
                                if (this.bonusCovered()) {
                                  this.payWithEasychawWallet(true);
                                } else {
                                  this.setState({
                                    ...this.state,
                                    useBonus: true,
                                    bonus:
                                      this.props.docs.wallets[
                                        this.props.profile.walletId
                                      ].bonuses,
                                  });
                                }
                              }}
                            >
                              {this.bonusCovered()
                                ? "Pay With Bonus"
                                : "Apply Bonus"}
                            </Button>
                          </CardFooter>
                        )}
                      </Card>
                    )}

                    {/* [Card - 7] Pay With Wallet */}
                    {!this.props.docs.wallets ||
                    (this.props.docs.wallets &&
                      this.props.docs.wallets[this.props.profile.walletId] &&
                      this.props.docs.wallets[this.props.profile.walletId]
                        .ban) ||
                    (Object.keys(this.state.postDatedOrders).length > 0 &&
                      Object.keys(this.state.postDatedOrders)
                        .filter(
                          (key) =>
                            checkFreeDelivery(
                              this.state.cart.find(
                                (cartObject) => cartObject.merchantId === key,
                              ).packages,
                              this.props.data.products,
                            ) === false,
                        )
                        .find(
                          (key) =>
                            this.state.postDatedOrders[key].deliveryAddress ===
                            "",
                        )) ||
                    !this.state.pay ||
                    !checkProductsAvailabilityForOrder(
                      this.props.cart,
                      this.props.data.products,
                    ) ||
                    !this.confirmQuantities(
                      this.props.cart,
                      this.props.data.products,
                    ) ||
                    (Object.keys(this.state.postDatedOrders).length > 0 &&
                      this.isAnyMerchantOutOfRange()) ||
                    this.isMerchantClosed() ||
                    this.isExpectedDeliveryTimeError() ? null : (
                      <Card style={{ marginBottom: 20 }}>
                        <CardHeader>
                          <span>
                            <Icon f7="lock_shield" color="green"></Icon>
                            &nbsp;&nbsp;&nbsp;Pay With Wallet
                          </span>

                          <Toggle
                            color="green"
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                easychawWallet: !this.state.easychawWallet,
                              })
                            }
                            checked={this.state.easychawWallet}
                          ></Toggle>
                        </CardHeader>
                        {this.state.easychawWallet ? (
                          !this.props.auth.isEmpty &&
                          (!this.props.profile.phoneNumber ||
                            this.props.profile.phoneNumber.trim() === "") ? (
                            <CardFooter>
                              <Block style={{ color: "red" }}>
                                Please update your phone number from your
                                profile before you can proceed
                              </Block>
                            </CardFooter>
                          ) : (
                            <>
                              <CardContent>
                                <List>
                                  <ListItem title="Wallet Balance">
                                    <small slot="after">
                                      {!this.props.profile.isEmpty &&
                                      this.props.docs.wallets &&
                                      this.props.docs.wallets[
                                        this.props.profile.walletId
                                      ]
                                        ? new Intl.NumberFormat("en-GB", {
                                            style: "currency",
                                            currency: "NGN",
                                          }).format(
                                            this.props.docs.wallets[
                                              this.props.profile.walletId
                                            ].cash -
                                              (+this.props.docs.wallets[
                                                this.props.profile.walletId
                                              ].pendingWithdrawal
                                                ? +this.props.docs.wallets[
                                                    this.props.profile.walletId
                                                  ].pendingWithdrawal
                                                    .map(
                                                      (pw) =>
                                                        pw.amount / 100 +
                                                        pw.reason.commission,
                                                    )
                                                    .reduce((a, b) => a + b, 0)
                                                : 0),
                                          )
                                        : 0}
                                    </small>
                                    <Icon f7="creditcard" slot="media" />
                                  </ListItem>
                                </List>
                              </CardContent>

                              {!this.props.profile.isEmpty &&
                              this.props.docs.wallets &&
                              this.props.docs.wallets[
                                this.props.profile.walletId
                              ] &&
                              this.props.data.products &&
                              (Number(
                                totalProductAndDeliveryCharge(
                                  this.props.cart,
                                  this.props.data.products,
                                  this.props.data.merchants,
                                  this.state.postDatedOrders,
                                  this.deliveryInclusive.bind(this),
                                  this.checkDeliveryMeans.bind(this),
                                  this.applyBonus.bind(this),
                                  this.props.data.settings?.["easychaw"],
                                ) +
                                  serviceCharge(
                                    this.props.cart,
                                    this.props.data.products,
                                    this.props.data.merchants,
                                    this.state.postDatedOrders,
                                    {
                                      percentageOrdersBelowAThousand:
                                        this.props.data.settings &&
                                        this.props.data.settings["easychaw"]
                                          ? this.props.data.settings["easychaw"]
                                              .percentageOrdersBelowAThousand
                                          : 2.55,
                                      percentageOrdersAboveAThousand:
                                        this.props.data.settings &&
                                        this.props.data.settings["easychaw"]
                                          ? this.props.data.settings["easychaw"]
                                              .percentageOrdersAboveAThousand
                                          : 3.95,
                                    },
                                    this.deliveryInclusive.bind(this),
                                    this.checkDeliveryMeans.bind(this),
                                    this.state.easychawWallet,
                                    this.props.data.settings?.["easychaw"],
                                  ),
                              ) >
                                +this.props.docs.wallets[
                                  this.props.profile.walletId
                                ].cash ||
                                Number(
                                  totalProductAndDeliveryCharge(
                                    this.props.cart,
                                    this.props.data.products,
                                    this.props.data.merchants,
                                    this.state.postDatedOrders,
                                    this.deliveryInclusive.bind(this),
                                    this.checkDeliveryMeans.bind(this),
                                    this.applyBonus.bind(this),
                                    this.props.data.settings?.["easychaw"],
                                  ) +
                                    serviceCharge(
                                      this.props.cart,
                                      this.props.data.products,
                                      this.props.data.merchants,
                                      this.state.postDatedOrders,
                                      {
                                        percentageOrdersBelowAThousand:
                                          this.props.data.settings &&
                                          this.props.data.settings["easychaw"]
                                            ? this.props.data.settings[
                                                "easychaw"
                                              ].percentageOrdersBelowAThousand
                                            : 2.55,
                                        percentageOrdersAboveAThousand:
                                          this.props.data.settings &&
                                          this.props.data.settings["easychaw"]
                                            ? this.props.data.settings[
                                                "easychaw"
                                              ].percentageOrdersAboveAThousand
                                            : 3.95,
                                      },
                                      this.deliveryInclusive.bind(this),
                                      this.checkDeliveryMeans.bind(this),
                                      this.state.easychawWallet,
                                      this.props.data.settings?.["easychaw"],
                                    ),
                                ) >
                                  +this.props.docs.wallets[
                                    this.props.profile.walletId
                                  ].cash -
                                    (+this.props.docs.wallets[
                                      this.props.profile.walletId
                                    ].pendingWithdrawal
                                      ? +this.props.docs.wallets[
                                          this.props.profile.walletId
                                        ].pendingWithdrawal
                                          .map(
                                            (pw) =>
                                              pw.amount / 100 +
                                              pw.reason.commission,
                                          )
                                          .reduce((a, b) => a + b, 0)
                                      : 0)) ? (
                                <CardFooter className="no-padding">
                                  <Block
                                    className="pab"
                                    style={{ width: "100%" }}
                                  >
                                    <Row noGap>
                                      <Col width="10">
                                        <Icon f7="exclamationmark_triangle"></Icon>
                                      </Col>
                                      <Col width="60">
                                        Insufficient balance, please fund your
                                        Easychaw Wallet or use paystack to
                                        complete payment
                                      </Col>
                                      <Col width="30">
                                        <Link
                                          className="pal"
                                          onClick={() => {
                                            this.$f7.tab.show(
                                              `#view-account`,
                                              false,
                                            );
                                            this.$f7.methods.navAccount(
                                              "profile",
                                            );
                                            this.$f7.views.account.router.navigate(
                                              "/profile/2/",
                                            );
                                          }}
                                        >
                                          Fund Wallet
                                        </Link>
                                      </Col>
                                    </Row>
                                  </Block>
                                </CardFooter>
                              ) : (
                                <CardFooter>
                                  <Button
                                    fill
                                    className="button-fill-blue"
                                    style={{ width: "100%" }}
                                    onClick={(e) =>
                                      this.payWithEasychawWallet()
                                    }
                                  >
                                    Checkout
                                  </Button>
                                </CardFooter>
                              )}
                            </>
                          )
                        ) : null}
                      </Card>
                    )}

                    {/* [Card - 8] Pay With Paystack */}
                    {(Object.keys(this.state.postDatedOrders).length > 0 &&
                      Object.keys(this.state.postDatedOrders)
                        .filter(
                          (key) =>
                            checkFreeDelivery(
                              this.state.cart.find(
                                (cartObject) => cartObject.merchantId === key,
                              ).packages,
                              this.props.data.products,
                            ) === false,
                        )
                        .find(
                          (key) =>
                            this.state.postDatedOrders[key].deliveryAddress ===
                            "",
                        )) ||
                    !this.state.pay ||
                    !checkProductsAvailabilityForOrder(
                      this.props.cart,
                      this.props.data.products,
                    ) ||
                    !this.confirmQuantities(
                      this.props.cart,
                      this.props.data.products,
                    ) ||
                    (Object.keys(this.state.postDatedOrders).length > 0 &&
                      this.isAnyMerchantOutOfRange()) ||
                    this.isMerchantClosed() ||
                    this.isExpectedDeliveryTimeError() ? null : (
                      <Card style={{ marginBottom: 20 }}>
                        <CardHeader>
                          <span>
                            <Icon f7="lock_shield" color="green"></Icon>
                            &nbsp;&nbsp;&nbsp;Pay With Card
                          </span>
                          <Toggle
                            color="green"
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                easychawWallet: !this.state.easychawWallet,
                              })
                            }
                            checked={!this.state.easychawWallet}
                          ></Toggle>
                        </CardHeader>
                        {!this.state.easychawWallet ? (
                          <>
                            {/* Send user to account page once order has been placed; also update merchant and admin db with new order */}

                            {!this.props.auth.isEmpty &&
                            (!this.props.profile.phoneNumber ||
                              this.props.profile.phoneNumber.trim() === "") ? (
                              <CardFooter>
                                <Block style={{ color: "red" }}>
                                  Please update your phone number from your
                                  profile before you can proceed
                                </Block>
                              </CardFooter>
                            ) : (
                              <>
                                <CardContent
                                  padding={false}
                                  className="padding-bottom"
                                >
                                  <Block className="margin-top">
                                    <PaystackButton
                                      text="Continue with Paystack"
                                      className="button button-fill-blue"
                                      onSuccess={this.callback.bind(this)}
                                      onClose={this.close}
                                      reference={this.reference()}
                                      email={
                                        !this.props.profile.isEmpty &&
                                        this.props.profile.email
                                      }
                                      metadata={{
                                        name:
                                          !this.props.profile.isEmpty &&
                                          this.props.profile.fullName,
                                        phone:
                                          !this.props.profile.isEmpty &&
                                          this.props.profile.phoneNumber,
                                        orders:
                                          this.props.data.products &&
                                          this.props.cart.map((cartObject) => {
                                            let packages =
                                              cartObject.packages.map(
                                                (product) => ({
                                                  ...product,
                                                  preparationTime:
                                                    this.props.data.products[
                                                      product.productId
                                                    ].preparationTime,
                                                  name: this.props.data
                                                    .products[product.productId]
                                                    .name,
                                                  discount:
                                                    this.props.data.products[
                                                      product.productId
                                                    ].discount,
                                                  amount:
                                                    this.props.data.products[
                                                      product.productId
                                                    ].discount === "" ||
                                                    +this.props.data.products[
                                                      product.productId
                                                    ].discount < 1
                                                      ? +(
                                                          Number(
                                                            product.count,
                                                          ) *
                                                          +this.props.data
                                                            .products[
                                                            product.productId
                                                          ].price
                                                        ).toFixed(2)
                                                      : +(
                                                          +product.count *
                                                          (+this.props.data
                                                            .products[
                                                            product.productId
                                                          ].price -
                                                            (+this.props.data
                                                              .products[
                                                              product.productId
                                                            ].discount /
                                                              100) *
                                                              +this.props.data
                                                                .products[
                                                                product
                                                                  .productId
                                                              ].price)
                                                        ).toFixed(2),

                                                  merchantAmount:
                                                    this.props.data.products[
                                                      product.productId
                                                    ].discount === "" ||
                                                    +this.props.data.products[
                                                      product.productId
                                                    ].discount < 1
                                                      ? +(
                                                          Number(
                                                            product.count,
                                                          ) *
                                                          (+this.props.data
                                                            .products[
                                                            product.productId
                                                          ].price -
                                                            ((this.props.data
                                                              .settings
                                                              ?.easychaw
                                                              ?.promo?.[
                                                              cartObject
                                                                .merchantId
                                                            ]
                                                              ?.commissionOnSales ||
                                                              3.5) /
                                                              100) *
                                                              +this.props.data
                                                                .products[
                                                                product
                                                                  .productId
                                                              ].price)
                                                        ).toFixed(2)
                                                      : +(
                                                          Number(
                                                            product.count,
                                                          ) *
                                                          (+this.props.data
                                                            .products[
                                                            product.productId
                                                          ].price -
                                                            (+this.props.data
                                                              .products[
                                                              product.productId
                                                            ].discount /
                                                              100) *
                                                              +this.props.data
                                                                .products[
                                                                product
                                                                  .productId
                                                              ].price -
                                                            ((this.props.data
                                                              .settings
                                                              ?.easychaw
                                                              ?.promo?.[
                                                              cartObject
                                                                .merchantId
                                                            ]
                                                              ?.commissionOnSales ??
                                                              3.5) /
                                                              100) *
                                                              (+this.props.data
                                                                .products[
                                                                product
                                                                  .productId
                                                              ].price -
                                                                (+this.props
                                                                  .data
                                                                  .products[
                                                                  product
                                                                    .productId
                                                                ].discount /
                                                                  100) *
                                                                  +this.props
                                                                    .data
                                                                    .products[
                                                                    product
                                                                      .productId
                                                                  ].price))
                                                        ).toFixed(2),
                                                  userAmount: Math.ceil(
                                                    Number(product.count) *
                                                      Number(
                                                        totalProductPrice(
                                                          this.props.data
                                                            .products[
                                                            product.productId
                                                          ].price,
                                                          this.props.data
                                                            .products[
                                                            product.productId
                                                          ].discount,
                                                        ),
                                                      ),
                                                  ),
                                                }),
                                              );

                                            return {
                                              ...cartObject,
                                              packages: [...packages],
                                              completed: false,
                                              orderStatus: "Order Pending",
                                              qualifiedForEasychawBonus:
                                                userQualifiedForEasychawDiscount(
                                                  this.props.cart,
                                                  this.props.data.products,
                                                )
                                                  ? true
                                                  : false,
                                              deliveryRequired:
                                                checkFreeDelivery(
                                                  packages,
                                                  this.props.data.products,
                                                )
                                                  ? false
                                                  : true, // NOTE: Is this gonna be provided by the user?
                                              expectedDeliveryTime:
                                                this.state.expectedDeliveryTime[
                                                  cartObject.merchantId
                                                ] &&
                                                this.state.expectedDeliveryTime[
                                                  cartObject.merchantId
                                                ].time,
                                              postDatedDate:
                                                this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ] &&
                                                this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ].postDatedDate
                                                  ? this.state.postDatedOrders[
                                                      cartObject.merchantId
                                                    ].postDatedDate
                                                  : "",
                                              postDatedInstructions:
                                                this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ] &&
                                                this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ].postDatedInstructions
                                                  ? this.state.postDatedOrders[
                                                      cartObject.merchantId
                                                    ].postDatedInstructions
                                                  : null,
                                              deliveryAddress:
                                                this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ] &&
                                                this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ].deliveryAddress,
                                              geoLoc: this.state
                                                .postDatedOrders[
                                                cartObject.merchantId
                                              ] && {
                                                ...this.state.postDatedOrders[
                                                  cartObject.merchantId
                                                ].geoLoc,
                                              },
                                              fullName:
                                                this.props.profile.fullName,
                                              phoneNumber: this.props.profile
                                                .phoneNumber
                                                ? this.props.profile.phoneNumber
                                                : null,
                                              email: this.props.profile.email,
                                              userId: this.props.auth.uid,
                                              relId: this.state.relId,
                                              reference: this.state.reference,
                                              distanceFromMerchant: Math.ceil(
                                                getDistance(
                                                  this.props.data.merchants[
                                                    cartObject.merchantId
                                                  ].businessProfile.geoLoc,
                                                  this.state.postDatedOrders[
                                                    cartObject.merchantId
                                                  ].geoLoc,
                                                ) / 1000,
                                              ),
                                              confirmationCode:
                                                cryptoRandomString({
                                                  length: 6,
                                                  type: "numeric",
                                                }),
                                              deliveryAgentDeliveryCharge:
                                                checkFreeDelivery(
                                                  packages,
                                                  this.props.data.products,
                                                )
                                                  ? 0
                                                  : +(
                                                      deliveryCharge(
                                                        this.props.data
                                                          .merchants[
                                                          cartObject.merchantId
                                                        ].businessProfile
                                                          .geoLoc,
                                                        this.state
                                                          .postDatedOrders[
                                                          cartObject.merchantId
                                                        ].geoLoc,
                                                        {
                                                          defaultDeliveryCharge:
                                                            this.props.data
                                                              .settings &&
                                                            this.props.data
                                                              .settings[
                                                              "easychaw"
                                                            ]
                                                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                  cartObject,
                                                                )
                                                                  ?.deliveryCharge ||
                                                                  this.props
                                                                    .data
                                                                    .settings[
                                                                    "easychaw"
                                                                  ]
                                                                    .defaultDeliveryCharge) *
                                                                this.checkDeliveryMeans(
                                                                  packages,
                                                                )
                                                              : 500,
                                                          perKmDeliveryCharge:
                                                            this.props.data
                                                              .settings &&
                                                            this.props.data
                                                              .settings[
                                                              "easychaw"
                                                            ]
                                                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                  cartObject,
                                                                )
                                                                  ?.kmPerDeliveryCharge ||
                                                                  this.props
                                                                    .data
                                                                    .settings[
                                                                    "easychaw"
                                                                  ]
                                                                    .perKmDeliveryCharge) *
                                                                this.checkDeliveryMeans(
                                                                  packages,
                                                                )
                                                              : 50,
                                                        },
                                                        this.deliveryInclusive(
                                                          packages,
                                                        ),
                                                      ) -
                                                      (3.5 / 100) *
                                                        deliveryCharge(
                                                          this.props.data
                                                            .merchants[
                                                            cartObject
                                                              .merchantId
                                                          ].businessProfile
                                                            .geoLoc,
                                                          this.state
                                                            .postDatedOrders[
                                                            cartObject
                                                              .merchantId
                                                          ].geoLoc,
                                                          {
                                                            defaultDeliveryCharge:
                                                              this.props.data
                                                                .settings &&
                                                              this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                    cartObject,
                                                                  )
                                                                    ?.deliveryCharge ||
                                                                    this.props
                                                                      .data
                                                                      .settings[
                                                                      "easychaw"
                                                                    ]
                                                                      .defaultDeliveryCharge) *
                                                                  this.checkDeliveryMeans(
                                                                    packages,
                                                                  )
                                                                : 500,
                                                            perKmDeliveryCharge:
                                                              this.props.data
                                                                .settings &&
                                                              this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                    cartObject,
                                                                  )
                                                                    ?.kmPerDeliveryCharge ||
                                                                    this.props
                                                                      .data
                                                                      .settings[
                                                                      "easychaw"
                                                                    ]
                                                                      .perKmDeliveryCharge) *
                                                                  this.checkDeliveryMeans(
                                                                    packages,
                                                                  )
                                                                : 50,
                                                          },
                                                          this.deliveryInclusive(
                                                            packages,
                                                          ),
                                                        )
                                                    ).toFixed(2),
                                              userDeliveryCharge:
                                                checkFreeDelivery(
                                                  packages,
                                                  this.props.data.products,
                                                )
                                                  ? 0
                                                  : Math.ceil(
                                                      deliveryCharge(
                                                        this.props.data
                                                          .merchants[
                                                          cartObject.merchantId
                                                        ].businessProfile
                                                          .geoLoc,
                                                        this.state
                                                          .postDatedOrders[
                                                          cartObject.merchantId
                                                        ].geoLoc,
                                                        {
                                                          defaultDeliveryCharge:
                                                            this.props.data
                                                              .settings &&
                                                            this.props.data
                                                              .settings[
                                                              "easychaw"
                                                            ]
                                                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                  cartObject,
                                                                )
                                                                  ?.deliveryCharge ||
                                                                  this.props
                                                                    .data
                                                                    .settings[
                                                                    "easychaw"
                                                                  ]
                                                                    .defaultDeliveryCharge) *
                                                                this.checkDeliveryMeans(
                                                                  packages,
                                                                )
                                                              : 500,
                                                          perKmDeliveryCharge:
                                                            this.props.data
                                                              .settings &&
                                                            this.props.data
                                                              .settings[
                                                              "easychaw"
                                                            ]
                                                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                  cartObject,
                                                                )
                                                                  ?.kmPerDeliveryCharge ||
                                                                  this.props
                                                                    .data
                                                                    .settings[
                                                                    "easychaw"
                                                                  ]
                                                                    .perKmDeliveryCharge) *
                                                                this.checkDeliveryMeans(
                                                                  packages,
                                                                )
                                                              : 50,
                                                        },
                                                        this.deliveryInclusive(
                                                          packages,
                                                        ),
                                                      ),
                                                    ),
                                              deliveryInclusive:
                                                this.deliveryInclusive(packages)
                                                  .inclusive,
                                              commissionFreeSales:
                                                this.props.data.settings
                                                  ?.easychaw?.promo?.[
                                                  cartObject.merchantId
                                                ]?.commissionFreeSales ??
                                                this.props.data.settings
                                                  ?.easychaw
                                                  ?.defaultCommissionFreeSales,
                                              commissionOnSales:
                                                this.props.data.settings
                                                  ?.easychaw?.promo?.[
                                                  cartObject.merchantId
                                                ]?.commissionOnSales ?? 3.5,
                                              totalAmount:
                                                !this.deliveryInclusive(
                                                  packages,
                                                ).inclusive
                                                  ? packages
                                                      .map((p) => p.amount)
                                                      .reduce(
                                                        (a, b) =>
                                                          Number(a) + Number(b),
                                                        0,
                                                      )
                                                  : packages
                                                      .map((p) => p.amount)
                                                      .reduce(
                                                        (a, b) =>
                                                          Number(a) + Number(b),
                                                        0,
                                                      ) +
                                                    (checkFreeDelivery(
                                                      packages,
                                                      this.props.data.products,
                                                    )
                                                      ? 0
                                                      : +deliveryCharge(
                                                          this.props.data
                                                            .merchants[
                                                            cartObject
                                                              .merchantId
                                                          ].businessProfile
                                                            .geoLoc,
                                                          this.state
                                                            .postDatedOrders[
                                                            cartObject
                                                              .merchantId
                                                          ].geoLoc,
                                                          {
                                                            defaultDeliveryCharge:
                                                              this.props.data
                                                                .settings &&
                                                              this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                    cartObject,
                                                                  )
                                                                    ?.deliveryCharge ||
                                                                    this.props
                                                                      .data
                                                                      .settings[
                                                                      "easychaw"
                                                                    ]
                                                                      .defaultDeliveryCharge) *
                                                                  this.checkDeliveryMeans(
                                                                    packages,
                                                                  )
                                                                : 500,
                                                            perKmDeliveryCharge:
                                                              this.props.data
                                                                .settings &&
                                                              this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                    cartObject,
                                                                  )
                                                                    ?.kmPerDeliveryCharge ||
                                                                    this.props
                                                                      .data
                                                                      .settings[
                                                                      "easychaw"
                                                                    ]
                                                                      .perKmDeliveryCharge) *
                                                                  this.checkDeliveryMeans(
                                                                    packages,
                                                                  )
                                                                : 50,
                                                          },
                                                          this.deliveryInclusive(
                                                            packages,
                                                          ),
                                                        ).toFixed(2)),
                                              totalMerchantAmount:
                                                !this.deliveryInclusive(
                                                  packages,
                                                ).inclusive
                                                  ? packages
                                                      .map(
                                                        (p) => p.merchantAmount,
                                                      )
                                                      .reduce(
                                                        (a, b) =>
                                                          Number(a) + Number(b),
                                                        0,
                                                      )
                                                  : packages
                                                      .map(
                                                        (p) => p.merchantAmount,
                                                      )
                                                      .reduce(
                                                        (a, b) =>
                                                          Number(a) + Number(b),
                                                        0,
                                                      ) +
                                                    (checkFreeDelivery(
                                                      packages,
                                                      this.props.data.products,
                                                    )
                                                      ? 0
                                                      : +(
                                                          deliveryCharge(
                                                            this.props.data
                                                              .merchants[
                                                              cartObject
                                                                .merchantId
                                                            ].businessProfile
                                                              .geoLoc,
                                                            this.state
                                                              .postDatedOrders[
                                                              cartObject
                                                                .merchantId
                                                            ].geoLoc,
                                                            {
                                                              defaultDeliveryCharge:
                                                                this.props.data
                                                                  .settings &&
                                                                this.props.data
                                                                  .settings[
                                                                  "easychaw"
                                                                ]
                                                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                      cartObject,
                                                                    )
                                                                      ?.deliveryCharge ||
                                                                      this.props
                                                                        .data
                                                                        .settings[
                                                                        "easychaw"
                                                                      ]
                                                                        .defaultDeliveryCharge) *
                                                                    this.checkDeliveryMeans(
                                                                      packages,
                                                                    )
                                                                  : 500,
                                                              perKmDeliveryCharge:
                                                                this.props.data
                                                                  .settings &&
                                                                this.props.data
                                                                  .settings[
                                                                  "easychaw"
                                                                ]
                                                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                      cartObject,
                                                                    )
                                                                      ?.kmPerDeliveryCharge ||
                                                                      this.props
                                                                        .data
                                                                        .settings[
                                                                        "easychaw"
                                                                      ]
                                                                        .perKmDeliveryCharge) *
                                                                    this.checkDeliveryMeans(
                                                                      packages,
                                                                    )
                                                                  : 50,
                                                            },
                                                            this.deliveryInclusive(
                                                              packages,
                                                            ),
                                                          ) -
                                                          ((this.props.data
                                                            .settings?.easychaw
                                                            ?.promo?.[
                                                            cartObject
                                                              .merchantId
                                                          ]
                                                            ?.commissionOnSales ??
                                                            3.5) /
                                                            100) *
                                                            deliveryCharge(
                                                              this.props.data
                                                                .merchants[
                                                                cartObject
                                                                  .merchantId
                                                              ].businessProfile
                                                                .geoLoc,
                                                              this.state
                                                                .postDatedOrders[
                                                                cartObject
                                                                  .merchantId
                                                              ].geoLoc,
                                                              {
                                                                defaultDeliveryCharge:
                                                                  this.props
                                                                    .data
                                                                    .settings &&
                                                                  this.props
                                                                    .data
                                                                    .settings[
                                                                    "easychaw"
                                                                  ]
                                                                    ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                        cartObject,
                                                                      )
                                                                        ?.deliveryCharge ||
                                                                        this
                                                                          .props
                                                                          .data
                                                                          .settings[
                                                                          "easychaw"
                                                                        ]
                                                                          .defaultDeliveryCharge) *
                                                                      this.checkDeliveryMeans(
                                                                        packages,
                                                                      )
                                                                    : 500,
                                                                perKmDeliveryCharge:
                                                                  this.props
                                                                    .data
                                                                    .settings &&
                                                                  this.props
                                                                    .data
                                                                    .settings[
                                                                    "easychaw"
                                                                  ]
                                                                    ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                                                        cartObject,
                                                                      )
                                                                        ?.kmPerDeliveryCharge ||
                                                                        this
                                                                          .props
                                                                          .data
                                                                          .settings[
                                                                          "easychaw"
                                                                        ]
                                                                          .perKmDeliveryCharge) *
                                                                      this.checkDeliveryMeans(
                                                                        packages,
                                                                      )
                                                                    : 50,
                                                              },
                                                              this.deliveryInclusive(
                                                                packages,
                                                              ),
                                                            )
                                                        ).toFixed(2)),
                                              totalUserAmount: packages
                                                .map((p) => p.userAmount)
                                                .reduce(
                                                  (a, b) =>
                                                    Number(a) + Number(b),
                                                  0,
                                                ),
                                              serviceCharge:
                                                this.props.data.products &&
                                                Math.ceil(
                                                  Number(
                                                    serviceCharge(
                                                      this.props.cart,
                                                      this.props.data.products,
                                                      this.props.data.merchants,
                                                      this.state
                                                        .postDatedOrders,
                                                      {
                                                        percentageOrdersBelowAThousand:
                                                          this.props.data
                                                            .settings &&
                                                          this.props.data
                                                            .settings[
                                                            "easychaw"
                                                          ]
                                                            ? this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                .percentageOrdersBelowAThousand
                                                            : 2.55,
                                                        percentageOrdersAboveAThousand:
                                                          this.props.data
                                                            .settings &&
                                                          this.props.data
                                                            .settings[
                                                            "easychaw"
                                                          ]
                                                            ? this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                .percentageOrdersAboveAThousand
                                                            : 3.95,
                                                      },
                                                      this.deliveryInclusive.bind(
                                                        this,
                                                      ),
                                                      this.checkDeliveryMeans.bind(
                                                        this,
                                                      ),
                                                      this.state.easychawWallet,
                                                      this.props.data
                                                        .settings?.["easychaw"],
                                                    ),
                                                  ),
                                                ),
                                            };
                                          }),
                                        transaction: {
                                          doc: this.state.reference,
                                          body: {
                                            walletId:
                                              this.props.profile.walletId,
                                            name: this.props.profile.fullName,
                                            status: "Success",
                                            type: "Received",
                                            by: "Easychaw",
                                            useBonus: this.state.useBonus,
                                            bonus: this.state.bonus,
                                            relId: this.state.relId,
                                            // This is service charge and no longer paystack charge. i didn't change it cos it will break alot of things
                                            paystackCharge:
                                              this.props.data.products &&
                                              Number(
                                                Math.ceil(
                                                  serviceCharge(
                                                    this.props.cart,
                                                    this.props.data.products,
                                                    this.props.data.merchants,
                                                    this.state.postDatedOrders,
                                                    {
                                                      percentageOrdersBelowAThousand:
                                                        this.props.data
                                                          .settings &&
                                                        this.props.data
                                                          .settings["easychaw"]
                                                          ? this.props.data
                                                              .settings[
                                                              "easychaw"
                                                            ]
                                                              .percentageOrdersBelowAThousand
                                                          : 2.55,
                                                      percentageOrdersAboveAThousand:
                                                        this.props.data
                                                          .settings &&
                                                        this.props.data
                                                          .settings["easychaw"]
                                                          ? this.props.data
                                                              .settings[
                                                              "easychaw"
                                                            ]
                                                              .percentageOrdersAboveAThousand
                                                          : 3.95,
                                                    },
                                                    this.deliveryInclusive.bind(
                                                      this,
                                                    ),
                                                    this.checkDeliveryMeans.bind(
                                                      this,
                                                    ),
                                                    this.state.easychawWallet,
                                                    this.props.data.settings?.[
                                                      "easychaw"
                                                    ],
                                                  ),
                                                ),
                                              ),
                                            amount:
                                              this.props.data.products &&
                                              Number(
                                                `${
                                                  Math.ceil(
                                                    totalProductAndDeliveryCharge(
                                                      this.props.cart,
                                                      this.props.data.products,
                                                      this.props.data.merchants,
                                                      this.state
                                                        .postDatedOrders,
                                                      this.deliveryInclusive.bind(
                                                        this,
                                                      ),
                                                      this.checkDeliveryMeans.bind(
                                                        this,
                                                      ),
                                                      this.applyBonus.bind(
                                                        this,
                                                      ),
                                                      this.props.data
                                                        .settings?.["easychaw"],
                                                    ),
                                                  ) +
                                                  Math.ceil(
                                                    serviceCharge(
                                                      this.props.cart,
                                                      this.props.data.products,
                                                      this.props.data.merchants,
                                                      this.state
                                                        .postDatedOrders,
                                                      {
                                                        percentageOrdersBelowAThousand:
                                                          this.props.data
                                                            .settings &&
                                                          this.props.data
                                                            .settings[
                                                            "easychaw"
                                                          ]
                                                            ? this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                .percentageOrdersBelowAThousand
                                                            : 2.55,
                                                        percentageOrdersAboveAThousand:
                                                          this.props.data
                                                            .settings &&
                                                          this.props.data
                                                            .settings[
                                                            "easychaw"
                                                          ]
                                                            ? this.props.data
                                                                .settings[
                                                                "easychaw"
                                                              ]
                                                                .percentageOrdersAboveAThousand
                                                            : 3.95,
                                                      },
                                                      this.deliveryInclusive.bind(
                                                        this,
                                                      ),
                                                      this.checkDeliveryMeans.bind(
                                                        this,
                                                      ),
                                                      this.state.easychawWallet,
                                                      this.props.data
                                                        .settings?.["easychaw"],
                                                    ),
                                                  )
                                                }`,
                                              ),
                                          },
                                        },
                                      }}
                                      amount={
                                        this.props.data.products &&
                                        Number(
                                          `${
                                            Math.ceil(
                                              totalProductAndDeliveryCharge(
                                                this.props.cart,
                                                this.props.data.products,
                                                this.props.data.merchants,
                                                this.state.postDatedOrders,
                                                this.deliveryInclusive.bind(
                                                  this,
                                                ),
                                                this.checkDeliveryMeans.bind(
                                                  this,
                                                ),
                                                this.applyBonus.bind(this),
                                                this.props.data.settings?.[
                                                  "easychaw"
                                                ],
                                              ),
                                            ) +
                                            Math.ceil(
                                              serviceCharge(
                                                this.props.cart,
                                                this.props.data.products,
                                                this.props.data.merchants,
                                                this.state.postDatedOrders,
                                                {
                                                  percentageOrdersBelowAThousand:
                                                    this.props.data.settings &&
                                                    this.props.data.settings[
                                                      "easychaw"
                                                    ]
                                                      ? this.props.data
                                                          .settings["easychaw"]
                                                          .percentageOrdersBelowAThousand
                                                      : 2.55,
                                                  percentageOrdersAboveAThousand:
                                                    this.props.data.settings &&
                                                    this.props.data.settings[
                                                      "easychaw"
                                                    ]
                                                      ? this.props.data
                                                          .settings["easychaw"]
                                                          .percentageOrdersAboveAThousand
                                                      : 3.95,
                                                },
                                                this.deliveryInclusive.bind(
                                                  this,
                                                ),
                                                this.checkDeliveryMeans.bind(
                                                  this,
                                                ),
                                                this.state.easychawWallet,
                                                this.props.data.settings?.[
                                                  "easychaw"
                                                ],
                                              ),
                                            )
                                          }`,
                                        ) * 100
                                      }
                                      publicKey={PAYSTACK_PUBLIC_KEY}
                                    />
                                  </Block>

                                  {!this.props.profile.isEmpty &&
                                    this.props.profile.cards &&
                                    this.props.profile.cards.length > 0 && (
                                      <>
                                        <BlockTitle className="margin-bottom text-align-center">
                                          or use saved card
                                        </BlockTitle>
                                        <List mediaList>
                                          {this.props.profile.cards.map(
                                            (card) => (
                                              <ListItem
                                                key={card.signature}
                                                radio
                                                name="saved-card"
                                                value=""
                                                title={card.bank}
                                                subtitle={
                                                  "Card number ending with " +
                                                  card.last4
                                                }
                                                defaultChecked={
                                                  this.state.savedCard
                                                    .authorization_code ==
                                                  card.authorization_code
                                                }
                                                onChange={(e) => {
                                                  this.setState({
                                                    ...this.state,
                                                    savedCard: {
                                                      ...this.state,
                                                      opened: true,
                                                      authorization_code:
                                                        card.authorization_code,
                                                      email: card.email,
                                                      last4: card.last4,
                                                    },
                                                  });
                                                }}
                                              >
                                                <img
                                                  src={
                                                    card.card_type ===
                                                    "mastercard"
                                                      ? `static/${card.card_type.trim()}.svg`
                                                      : false
                                                      ? `static/${card.card_type.trim()}.png`
                                                      : `static/${card.card_type.trim()}.png`
                                                  }
                                                  style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    objectFit: "contain",
                                                  }}
                                                  slot="after"
                                                />
                                              </ListItem>
                                            ),
                                          )}
                                        </List>
                                      </>
                                    )}
                                </CardContent>
                                {this.state.savedCard.opened ? (
                                  <CardFooter>
                                    <Button
                                      fill
                                      className="button button-fill-green"
                                      style={{ width: "100%" }}
                                      onClick={() =>
                                        this.purchaseWithCard(
                                          this.state.savedCard
                                            .authorization_code,
                                          this.state.savedCard.email,
                                        )
                                      }
                                    >
                                      Pay with card ending{" "}
                                      {this.state.savedCard.last4}
                                    </Button>
                                  </CardFooter>
                                ) : null}
                              </>
                            )}
                          </>
                        ) : null}
                      </Card>
                    )}

                    {/* [Card - 8] Unavailable Product */}
                    {this.props.data.products &&
                      Object.keys(this.props.data.products).length > 0 &&
                      (!checkProductsAvailabilityForOrder(
                        this.props.cart,
                        this.props.data.products,
                      ) ||
                        !this.confirmQuantities(
                          this.props.cart,
                          this.props.data.products,
                        )) && (
                        <Card style={{ marginBottom: 20 }}>
                          <CardHeader>
                            <span>Unavailable Product(s)</span>
                          </CardHeader>
                          <CardContent padding={false}>
                            <Block className="sdab" style={{ width: "100%" }}>
                              <Row noGap>
                                <Col width="10">
                                  <Icon f7="exclamationmark_triangle"></Icon>
                                </Col>
                                <Col width="90">
                                  Some products have been made unavailable by
                                  merchant or are above stocked.
                                </Col>
                              </Row>
                            </Block>
                          </CardContent>
                        </Card>
                      )}

                    {/* [Card - 9] out of range */}
                    {Object.keys(this.state.postDatedOrders).length > 0 &&
                      this.isAnyMerchantOutOfRange() && (
                        <Card style={{ marginBottom: 20 }}>
                          <CardHeader>
                            <span>Out of Range</span>
                          </CardHeader>
                          <CardContent padding={false}>
                            <Block className="sdab" style={{ width: "100%" }}>
                              <Row noGap>
                                <Col width="10">
                                  <Icon f7="exclamationmark_triangle"></Icon>
                                </Col>
                                <Col width="90">
                                  Some merchants locations are above 50km from
                                  your delivery address. Please remove from
                                  cart.
                                </Col>
                              </Row>
                            </Block>
                          </CardContent>
                        </Card>
                      )}

                    {/* [Card - 10] closed */}
                    {this.isMerchantClosed() && (
                      <Card style={{ marginBottom: 20 }}>
                        <CardHeader>
                          <span>Closed</span>
                        </CardHeader>
                        <CardContent padding={false}>
                          <Block className="sdab" style={{ width: "100%" }}>
                            <Row noGap>
                              <Col width="10">
                                <Icon f7="exclamationmark_triangle"></Icon>
                              </Col>
                              <Col width="90">
                                Some merchants to handle some of your cart items
                                are closed and unavailable at the moment.
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </Card>
                    )}

                    {/* [Card - 11] Expected delivery time */}
                    {this.isExpectedDeliveryTimeError() && (
                      <Card style={{ marginBottom: 20 }}>
                        <CardHeader>
                          <span>Expected Delivery Time</span>
                        </CardHeader>
                        <CardContent padding={false}>
                          <Block className="sdab" style={{ width: "100%" }}>
                            <Row noGap>
                              <Col width="10">
                                <Icon f7="exclamationmark_triangle"></Icon>
                              </Col>
                              <Col width="90">
                                Please input delivery time for all merchants
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </Card>
                    )}
                  </Col>
                )}
            </Row>
            {this.props.cart === null && (
              <>
                {!this.props.auth.isEmpty && (
                  <Block className="pattern-banner bg-color-theme">
                    <Card style={{ width: "100%", margin: 0 }}>
                      <CardHeader>
                        <h3 style={{ margin: 0 }}>Cart Items</h3>
                      </CardHeader>
                    </Card>
                  </Block>
                )}
                <div
                  style={{
                    position: "relative",
                    width: "300px",
                    margin: "5vh auto",
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  <img src="static/cart.gif" style={{ width: "300px" }} />
                  <h4>Your Cart Is Empty!</h4>
                  <h6>Pss! What you waiting on?</h6>
                  <Button round fill className="back">
                    Find restaurants near you!
                  </Button>
                </div>
              </>
            )}

            {/* Sub login screen */}
            <LoginScreen
              className="user-login-screen"
              opened={this.state.loginScreenOpened}
              onLoginScreenClosed={() => {
                this.setState({
                  ...this.state,
                  loginScreenOpened: false,
                  email: "",
                  password: "",
                  fullName: "",
                  phoneNumber: "",
                  signInButton: "Sign In",
                  registerButton: "Sign Up",
                  register: false,
                });
              }}
            >
              <Page loginScreen>
                <LoginScreenTitle style={{ fontFamily: "Italiana" }}>
                  Experience Easychaw&#8482;
                </LoginScreenTitle>
                <List form>
                  {this.state.register ? (
                    <ListInput
                      label="Full Name"
                      type="text"
                      placeholder="Your first and last name"
                      value={this.state.fullName}
                      onInput={(e) => {
                        this.setState({ fullName: e.target.value });
                      }}
                    />
                  ) : null}
                  {this.state.register ? (
                    <ListInput
                      label="Phone Number"
                      min="0"
                      type="number"
                      placeholder="Your phone number"
                      value={this.state.phoneNumber}
                      onInput={(e) => {
                        this.setState({ phoneNumber: e.target.value });
                      }}
                    />
                  ) : null}
                  <ListInput
                    label="Email Address"
                    type="email"
                    placeholder="Your email address"
                    value={this.state.email}
                    onInput={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                  />
                  <ListInput
                    label="Password"
                    type="password"
                    placeholder="Your password"
                    value={this.state.password}
                    onInput={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                  />
                </List>

                <List>
                  <BlockFooter>
                    {this.state.register ? (
                      <Button
                        fill
                        style={{ width: "45%", margin: "10px auto" }}
                        disabled={this.state.registerButton !== "Sign Up"}
                        onClick={this.register.bind(this)}
                      >
                        {this.state.registerButton}
                      </Button>
                    ) : (
                      <Button
                        fill
                        style={{ width: "45%", margin: "10px auto" }}
                        disabled={this.state.signInButton !== "Sign In"}
                        onClick={this.login.bind(this)}
                      >
                        {this.state.signInButton}
                      </Button>
                    )}
                    Sign into your account to Experience Easychaw&#8482;.
                    <br />
                    Easychaw let's you order and pay for meals online from
                    thousands of verified food vendors.
                    <br />
                    {this.state.register ? (
                      <>
                        Have an account?
                        <Button
                          onClick={() =>
                            this.setState({ ...this.state, register: false })
                          }
                          style={{ display: "inline-block" }}
                        >
                          Sign In
                        </Button>
                      </>
                    ) : (
                      <>
                        Don't have an account?
                        <Button
                          onClick={() =>
                            this.setState({ ...this.state, register: true })
                          }
                          style={{ display: "inline-block" }}
                        >
                          Sign Up
                        </Button>
                      </>
                    )}
                    <Button
                      loginScreenClose
                      style={{
                        width: "45%",
                        margin: "10px auto",
                        color: "gray",
                      }}
                    >
                      Maybe later
                    </Button>
                  </BlockFooter>
                </List>
              </Page>
            </LoginScreen>
          </>
        )}
      </Page>
    );
  }

  // life cycle
  componentDidMount() {
    const dateTimeInterval = setInterval(() => {
      getCurrentTime((error, currentDateTime) => {
        if (error) {
          return console.log(error);
        }

        this.setState({
          ...this.state,
          currentDateTime,
        });
      });
    }, 30000);

    this.setState({
      ...this.state,
      dateTimeInterval,
    });
    // set postdated orders state
    const postDatedOrders = {};
    if (this.props.cart) {
      this.props.cart.forEach((cartObject) => {
        postDatedOrders[cartObject.merchantId] = {
          deliveryAddress: this.props.discover.deliveryAddress,
          geoLoc: this.props.discover.geoLoc,
          editAddress: false,
        };
      });

      this.setState(
        {
          ...this.state,
          postDatedOrders,
        },
        () => {
          this.props.cart.forEach((cartObject) => {
            if (
              !checkFreeDelivery(cartObject.packages, this.props.data.products)
            ) {
              const input = document.querySelector(
                `#edit-address-${cartObject.merchantId} input`,
              );
              const autocomplete =
                window.google &&
                new window.google.maps.places.Autocomplete(input);
              autocomplete.setFields(["formatted_address", "geometry", "name"]);
              autocomplete.addListener("place_changed", () => {
                let response = autocomplete.getPlace();
                if (!response.geometry) {
                  this.setState({
                    ...this.state,
                    postDatedOrders: {
                      ...this.state.postDatedOrders,
                      [cartObject.merchantId]: {
                        ...this.state.postDatedOrders[cartObject.merchantId],
                        deliveryAddress: this.props.discover.deliveryAddress,
                      },
                    },
                    pay: false,
                  });
                  return toast(this.$f7.toast, {
                    text: `No details available for input: ${response.name}. Please make sure you select a suggestted place`,
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                }

                if (response) {
                  this.setState({
                    ...this.state,
                    postDatedOrders: {
                      ...this.state.postDatedOrders,
                      [cartObject.merchantId]: {
                        ...this.state.postDatedOrders[cartObject.merchantId],
                        deliveryAddress: response.name,
                        geoLoc: {
                          lat: response.geometry.location.lat(),
                          lng: response.geometry.location.lng(),
                        },
                      },
                    },
                    pay: true,
                  });
                }
              });
            }
          });
        },
      );
    }
  }

  componentWillUnmount() {
    if (this.state.dateTimeInterval) {
      clearInterval(this.state.dateTimeInterval);
      this.setState({
        ...this.state,
        dateTimeInterval: null,
      });
    }
  }

  //events
  onPageAfterIn() {
    this.$f7.methods.showFullText();
  }

  // get charges for merchant city
  getMerchantCityDefaultDeliveryKmCharges(cartObject) {
    const cityCharges =
      this.props.data.settings["easychaw"].deliveryChargesPerCity?.[
        this.props.data.merchants[cartObject.merchantId]?.businessProfile
          ?.country
      ]?.[
        this.props.data.merchants[cartObject.merchantId]?.businessProfile?.state
      ]?.[
        this.props.data.merchants[cartObject.merchantId]?.businessProfile?.city
      ];

    if (!cityCharges) return null;

    return cityCharges;
  }

  // check distance between user and vendor
  isMerchantWithinRange(merchantId, merchantGeoLoc) {
    if (
      convertDistance(
        getDistance(
          this.state.postDatedOrders[merchantId].geoLoc,
          merchantGeoLoc,
        ),
        "km",
      ) > 50
    ) {
      return false;
    } else {
      return true;
    }
  }

  // check for all merchants in cart for range
  isAnyMerchantOutOfRange() {
    let error = false;
    this.props.cart.forEach((cartObject) => {
      if (
        convertDistance(
          getDistance(
            this.state.postDatedOrders[cartObject.merchantId].geoLoc,
            this.props.data.merchants[cartObject.merchantId].businessProfile
              .geoLoc,
          ),
          "km",
        ) > 50
      ) {
        error = true;
      }
    });

    return error;
  }

  isMerchantClosed() {
    let error = false;
    this.props.cart.forEach((cartObject) => {
      if (
        !isMerchantOpen(
          this.state.currentDateTime,
          this.props.data.merchants?.[cartObject.merchantId]?.businessProfile
            .operationDays,
          this.props.data.merchants?.[cartObject.merchantId]?.businessProfile
            .operationTimes,
          this.props.data.merchants?.[cartObject.merchantId]?.businessProfile
            .operationStartTime,
          this.props.data.merchants?.[cartObject.merchantId]?.businessProfile
            .operationCloseTime,
        )
      ) {
        error = true;
      }
    });

    return error;
  }

  isExpectedDeliveryTimeError() {
    let error = false;
    const merchantIds = Object.keys(this.state.expectedDeliveryTime);
    if (!merchantIds.length) {
      error = true;
    }

    this.props.cart.forEach((cartObject) => {
      if (!this.state.expectedDeliveryTime[cartObject.merchantId]?.time) {
        error = true;
      }
    });

    return error;
  }

  // Check if vendor has the quantity of product
  conFirmQuantity(cartProduct, product) {
    if (product[cartProduct.productId].stocked) {
      if (
        cartProduct.count > parseInt(product[cartProduct.productId].stocked)
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  // confirm for all quantities
  confirmQuantities(cart, products) {
    let aboveStocked = cart
      .flatMap((cartObject) => cartObject.packages)
      .filter(
        (p) =>
          products[p.productId].stocked !== "" &&
          parseInt(products[p.productId].stocked) < p.count,
      );

    if (aboveStocked.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  // check delivery inclusive
  deliveryInclusive(packages) {
    if (
      packages.every(
        ({ productId }) =>
          this.props.data.products[productId].deliveryInclusive,
      )
    ) {
      return {
        inclusive: true,
        limit:
          this.props.data?.settings?.easychaw?.promo?.[
            this.props.data.products[packages[0].productId].merchantId
          ]?.deliveryInclusiveLimit ??
          this.props.data?.settings?.easychaw?.deliveryInclusiveLimit ??
          0,
        zeroLimit:
          this.props.data?.settings?.easychaw?.promo?.[
            this.props.data.products[packages[0].productId].merchantId
          ]?.deliveryInclusiveLimit === 0
            ? true
            : false,
      };
    } else {
      return { inclusive: false };
    }
  }

  // check delivery means
  checkDeliveryMeans(packages) {
    let products = packages.map(
      (product) =>
        this.props.data.products[product.productId].deliveryMeans || 1,
    );

    if (this.props.data?.settings?.easychaw?.deliveryChargeMultiplier) {
      return (
        this.props.data.settings?.easychaw?.deliveryChargeMultiplier?.[
          `${Math.max(...products)}`
        ] || 1
      );
    } else {
      return 1;
    }
  }

  applyBonus() {
    if (this.state.useBonus) {
      return this.props.docs.wallets &&
        this.props.docs.wallets[this.props.profile.walletId]
        ? this.props.docs.wallets[this.props.profile.walletId].bonuses
        : 0;
    } else {
      return 0;
    }
  }

  bonusCovered() {
    if (
      +this.props.docs.wallets[this.props.profile.walletId]?.bonuses >=
      (this.props.data.products &&
        Number(
          `${
            Math.ceil(
              totalProductAndDeliveryCharge(
                this.props.cart,
                this.props.data.products,
                this.props.data.merchants,
                this.state.postDatedOrders,
                this.deliveryInclusive.bind(this),
                this.checkDeliveryMeans.bind(this),
                this.applyBonus.bind(this),
                this.props.data.settings?.["easychaw"],
              ),
            ) +
            Math.ceil(
              serviceCharge(
                this.props.cart,
                this.props.data.products,
                this.props.data.merchants,
                this.state.postDatedOrders,
                {
                  percentageOrdersBelowAThousand:
                    this.props.data.settings &&
                    this.props.data.settings["easychaw"]
                      ? this.props.data.settings["easychaw"]
                          .percentageOrdersBelowAThousand
                      : 2.55,
                  percentageOrdersAboveAThousand:
                    this.props.data.settings &&
                    this.props.data.settings["easychaw"]
                      ? this.props.data.settings["easychaw"]
                          .percentageOrdersAboveAThousand
                      : 3.95,
                },
                this.deliveryInclusive.bind(this),
                this.checkDeliveryMeans.bind(this),
                this.state.easychawWallet,
                this.props.data.settings?.["easychaw"],
              ),
            )
          }`,
        ))
    ) {
      return true;
    } else {
      return false;
    }
  }

  purchaseWithCard(authorizationCode, email) {
    this.$f7.preloader.show();
    const reference = this.reference();

    const amount =
      this.props.data.products &&
      Number(
        `${
          Math.ceil(
            totalProductAndDeliveryCharge(
              this.props.cart,
              this.props.data.products,
              this.props.data.merchants,
              this.state.postDatedOrders,
              this.deliveryInclusive.bind(this),
              this.checkDeliveryMeans.bind(this),
              this.applyBonus.bind(this),
              this.props.data.settings?.["easychaw"],
            ),
          ) +
          Math.ceil(
            serviceCharge(
              this.props.cart,
              this.props.data.products,
              this.props.data.merchants,
              this.state.postDatedOrders,
              {
                percentageOrdersBelowAThousand:
                  this.props.data.settings &&
                  this.props.data.settings["easychaw"]
                    ? this.props.data.settings["easychaw"]
                        .percentageOrdersBelowAThousand
                    : 2.55,
                percentageOrdersAboveAThousand:
                  this.props.data.settings &&
                  this.props.data.settings["easychaw"]
                    ? this.props.data.settings["easychaw"]
                        .percentageOrdersAboveAThousand
                    : 3.95,
              },
              this.deliveryInclusive.bind(this),
              this.checkDeliveryMeans.bind(this),
              this.state.easychawWallet,
              this.props.data.settings?.["easychaw"],
            ),
          )
        }`,
      );

    if (Number(amount) <= 0) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Error placing order. Please try again or contact us at support@easychaw.com",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        const metadata = {
          name: !this.props.profile.isEmpty && this.props.profile.fullName,
          phone: !this.props.profile.isEmpty && this.props.profile.phoneNumber,
          orders:
            this.props.data.products &&
            this.props.cart.map((cartObject) => {
              let packages = cartObject.packages.map((product) => ({
                ...product,
                preparationTime:
                  this.props.data.products[product.productId].preparationTime,
                name: this.props.data.products[product.productId].name,
                discount: this.props.data.products[product.productId].discount,
                amount:
                  this.props.data.products[product.productId].discount === "" ||
                  +this.props.data.products[product.productId].discount < 1
                    ? +(
                        Number(product.count) *
                        +this.props.data.products[product.productId].price
                      ).toFixed(2)
                    : +(
                        +product.count *
                        (+this.props.data.products[product.productId].price -
                          (+this.props.data.products[product.productId]
                            .discount /
                            100) *
                            +this.props.data.products[product.productId].price)
                      ).toFixed(2),

                merchantAmount:
                  this.props.data.products[product.productId].discount === "" ||
                  +this.props.data.products[product.productId].discount < 1
                    ? +(
                        Number(product.count) *
                        (+this.props.data.products[product.productId].price -
                          ((this.props.data.settings?.easychaw?.promo?.[
                            cartObject.merchantId
                          ]?.commissionOnSales || 3.5) /
                            100) *
                            +this.props.data.products[product.productId].price)
                      ).toFixed(2)
                    : +(
                        Number(product.count) *
                        (+this.props.data.products[product.productId].price -
                          (+this.props.data.products[product.productId]
                            .discount /
                            100) *
                            +this.props.data.products[product.productId].price -
                          ((this.props.data.settings?.easychaw?.promo?.[
                            cartObject.merchantId
                          ]?.commissionOnSales || 3.5) /
                            100) *
                            (+this.props.data.products[product.productId]
                              .price -
                              (+this.props.data.products[product.productId]
                                .discount /
                                100) *
                                +this.props.data.products[product.productId]
                                  .price))
                      ).toFixed(2),
                userAmount: Math.ceil(
                  Number(product.count) *
                    Number(
                      totalProductPrice(
                        this.props.data.products[product.productId].price,
                        this.props.data.products[product.productId].discount,
                      ),
                    ),
                ),
              }));

              return {
                ...cartObject,
                packages: [...packages],
                completed: false,
                orderStatus: "Order Pending",
                qualifiedForEasychawBonus: userQualifiedForEasychawDiscount(
                  this.props.cart,
                  this.props.data.products,
                )
                  ? true
                  : false,
                deliveryRequired: checkFreeDelivery(
                  packages,
                  this.props.data.products,
                )
                  ? false
                  : true,
                expectedDeliveryTime:
                  this.state.expectedDeliveryTime[cartObject.merchantId] &&
                  this.state.expectedDeliveryTime[cartObject.merchantId].time,
                postDatedDate:
                  this.state.postDatedOrders[cartObject.merchantId] &&
                  this.state.postDatedOrders[cartObject.merchantId]
                    .postDatedDate
                    ? this.state.postDatedOrders[cartObject.merchantId]
                        .postDatedDate
                    : "",
                postDatedInstructions:
                  this.state.postDatedOrders[cartObject.merchantId] &&
                  this.state.postDatedOrders[cartObject.merchantId]
                    .postDatedInstructions
                    ? this.state.postDatedOrders[cartObject.merchantId]
                        .postDatedInstructions
                    : null,
                deliveryAddress:
                  this.state.postDatedOrders[cartObject.merchantId] &&
                  this.state.postDatedOrders[cartObject.merchantId]
                    .deliveryAddress,
                geoLoc: this.state.postDatedOrders[cartObject.merchantId] && {
                  ...this.state.postDatedOrders[cartObject.merchantId].geoLoc,
                },
                fullName: this.props.profile.fullName,
                phoneNumber: this.props.profile.phoneNumber
                  ? this.props.profile.phoneNumber
                  : null,
                email: this.props.profile.email,
                userId: this.props.auth.uid,
                relId: this.state.relId,
                reference,
                distanceFromMerchant: Math.ceil(
                  getDistance(
                    this.props.data.merchants[cartObject.merchantId]
                      .businessProfile.geoLoc,
                    this.state.postDatedOrders[cartObject.merchantId].geoLoc,
                  ) / 1000,
                ),
                confirmationCode: cryptoRandomString({
                  length: 6,
                  type: "numeric",
                }),
                deliveryAgentDeliveryCharge: checkFreeDelivery(
                  packages,
                  this.props.data.products,
                )
                  ? 0
                  : +(
                      deliveryCharge(
                        this.props.data.merchants[cartObject.merchantId]
                          .businessProfile.geoLoc,
                        this.state.postDatedOrders[cartObject.merchantId]
                          .geoLoc,
                        {
                          defaultDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.deliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .defaultDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 500,
                          perKmDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.kmPerDeliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .perKmDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 50,
                        },
                        this.deliveryInclusive(packages),
                      ) -
                      (3.5 / 100) *
                        deliveryCharge(
                          this.props.data.merchants[cartObject.merchantId]
                            .businessProfile.geoLoc,
                          this.state.postDatedOrders[cartObject.merchantId]
                            .geoLoc,
                          {
                            defaultDeliveryCharge:
                              this.props.data.settings &&
                              this.props.data.settings["easychaw"]
                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                    cartObject,
                                  )?.deliveryCharge ||
                                    this.props.data.settings["easychaw"]
                                      .defaultDeliveryCharge) *
                                  this.checkDeliveryMeans(packages)
                                : 500,
                            perKmDeliveryCharge:
                              this.props.data.settings &&
                              this.props.data.settings["easychaw"]
                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                    cartObject,
                                  )?.kmPerDeliveryCharge ||
                                    this.props.data.settings["easychaw"]
                                      .perKmDeliveryCharge) *
                                  this.checkDeliveryMeans(packages)
                                : 50,
                          },
                          this.deliveryInclusive(packages),
                        )
                    ).toFixed(2),
                userDeliveryCharge: checkFreeDelivery(
                  packages,
                  this.props.data.products,
                )
                  ? 0
                  : Math.ceil(
                      deliveryCharge(
                        this.props.data.merchants[cartObject.merchantId]
                          .businessProfile.geoLoc,
                        this.state.postDatedOrders[cartObject.merchantId]
                          .geoLoc,
                        {
                          defaultDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.deliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .defaultDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 500,
                          perKmDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.kmPerDeliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .perKmDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 50,
                        },
                        this.deliveryInclusive(packages),
                      ),
                    ),
                deliveryInclusive: this.deliveryInclusive(packages).inclusive,
                commissionFreeSales:
                  this.props.data.settings?.easychaw?.promo?.[
                    cartObject.merchantId
                  ]?.commissionFreeSales ??
                  this.props.data.settings?.easychaw
                    ?.defaultCommissionFreeSales,
                commissionOnSales:
                  this.props.data.settings?.easychaw?.promo?.[
                    cartObject.merchantId
                  ]?.commissionOnSales ?? 3.5,
                totalAmount: !this.deliveryInclusive(packages).inclusive
                  ? packages
                      .map((p) => p.amount)
                      .reduce((a, b) => Number(a) + Number(b), 0)
                  : packages
                      .map((p) => p.amount)
                      .reduce((a, b) => Number(a) + Number(b), 0) +
                    (checkFreeDelivery(packages, this.props.data.products)
                      ? 0
                      : +deliveryCharge(
                          this.props.data.merchants[cartObject.merchantId]
                            .businessProfile.geoLoc,
                          this.state.postDatedOrders[cartObject.merchantId]
                            .geoLoc,
                          {
                            defaultDeliveryCharge:
                              this.props.data.settings &&
                              this.props.data.settings["easychaw"]
                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                    cartObject,
                                  )?.deliveryCharge ||
                                    this.props.data.settings["easychaw"]
                                      .defaultDeliveryCharge) *
                                  this.checkDeliveryMeans(packages)
                                : 500,
                            perKmDeliveryCharge:
                              this.props.data.settings &&
                              this.props.data.settings["easychaw"]
                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                    cartObject,
                                  )?.kmPerDeliveryCharge ||
                                    this.props.data.settings["easychaw"]
                                      .perKmDeliveryCharge) *
                                  this.checkDeliveryMeans(packages)
                                : 50,
                          },
                          this.deliveryInclusive(packages),
                        ).toFixed(2)),
                totalMerchantAmount: !this.deliveryInclusive(packages).inclusive
                  ? packages
                      .map((p) => p.merchantAmount)
                      .reduce((a, b) => Number(a) + Number(b), 0)
                  : packages
                      .map((p) => p.merchantAmount)
                      .reduce((a, b) => Number(a) + Number(b), 0) +
                    (checkFreeDelivery(packages, this.props.data.products)
                      ? 0
                      : +(
                          deliveryCharge(
                            this.props.data.merchants[cartObject.merchantId]
                              .businessProfile.geoLoc,
                            this.state.postDatedOrders[cartObject.merchantId]
                              .geoLoc,
                            {
                              defaultDeliveryCharge:
                                this.props.data.settings &&
                                this.props.data.settings["easychaw"]
                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                      cartObject,
                                    )?.deliveryCharge ||
                                      this.props.data.settings["easychaw"]
                                        .defaultDeliveryCharge) *
                                    this.checkDeliveryMeans(packages)
                                  : 500,
                              perKmDeliveryCharge:
                                this.props.data.settings &&
                                this.props.data.settings["easychaw"]
                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                      cartObject,
                                    )?.kmPerDeliveryCharge ||
                                      this.props.data.settings["easychaw"]
                                        .perKmDeliveryCharge) *
                                    this.checkDeliveryMeans(packages)
                                  : 50,
                            },
                            this.deliveryInclusive(packages),
                          ) -
                          ((this.props.data.settings?.easychaw?.promo?.[
                            cartObject.merchantId
                          ]?.commissionOnSales ?? 3.5) /
                            100) *
                            deliveryCharge(
                              this.props.data.merchants[cartObject.merchantId]
                                .businessProfile.geoLoc,
                              this.state.postDatedOrders[cartObject.merchantId]
                                .geoLoc,
                              {
                                defaultDeliveryCharge:
                                  this.props.data.settings &&
                                  this.props.data.settings["easychaw"]
                                    ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                        cartObject,
                                      )?.deliveryCharge ||
                                        this.props.data.settings["easychaw"]
                                          .defaultDeliveryCharge) *
                                      this.checkDeliveryMeans(packages)
                                    : 500,
                                perKmDeliveryCharge:
                                  this.props.data.settings &&
                                  this.props.data.settings["easychaw"]
                                    ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                        cartObject,
                                      )?.kmPerDeliveryCharge ||
                                        this.props.data.settings["easychaw"]
                                          .perKmDeliveryCharge) *
                                      this.checkDeliveryMeans(packages)
                                    : 50,
                              },
                              this.deliveryInclusive(packages),
                            )
                        ).toFixed(2)),
                totalUserAmount: packages
                  .map((p) => p.userAmount)
                  .reduce((a, b) => Number(a) + Number(b), 0),
                serviceCharge:
                  this.props.data.products &&
                  Math.ceil(
                    Number(
                      serviceCharge(
                        this.props.cart,
                        this.props.data.products,
                        this.props.data.merchants,
                        this.state.postDatedOrders,
                        {
                          percentageOrdersBelowAThousand:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? this.props.data.settings["easychaw"]
                                  .percentageOrdersBelowAThousand
                              : 2.55,
                          percentageOrdersAboveAThousand:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? this.props.data.settings["easychaw"]
                                  .percentageOrdersAboveAThousand
                              : 3.95,
                        },
                        this.deliveryInclusive.bind(this),
                        this.checkDeliveryMeans.bind(this),
                        this.state.easychawWallet,
                        this.props.data.settings?.["easychaw"],
                      ),
                    ),
                  ),
              };
            }),
          transaction: {
            doc: reference,
            body: {
              walletId: this.props.profile.walletId,
              name: this.props.profile.fullName,
              status: "Success",
              type: "Received",
              by: "Easychaw",
              relId: this.state.relId,
              useBonus: this.state.useBonus,
              bonus: this.state.bonus,
              // This is service charge and no longer paystack charge. i didn't change it cos it will break alot of things
              paystackCharge:
                this.props.data.products &&
                Number(
                  Math.ceil(
                    serviceCharge(
                      this.props.cart,
                      this.props.data.products,
                      this.props.data.merchants,
                      this.state.postDatedOrders,
                      {
                        percentageOrdersBelowAThousand:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? this.props.data.settings["easychaw"]
                                .percentageOrdersBelowAThousand
                            : 2.55,
                        percentageOrdersAboveAThousand:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? this.props.data.settings["easychaw"]
                                .percentageOrdersAboveAThousand
                            : 3.95,
                      },
                      this.deliveryInclusive.bind(this),
                      this.checkDeliveryMeans.bind(this),
                      this.state.easychawWallet,
                      this.props.data.settings?.["easychaw"],
                    ),
                  ),
                ),
              amount:
                this.props.data.products &&
                Number(
                  `${
                    Math.ceil(
                      totalProductAndDeliveryCharge(
                        this.props.cart,
                        this.props.data.products,
                        this.props.data.merchants,
                        this.state.postDatedOrders,
                        this.deliveryInclusive.bind(this),
                        this.checkDeliveryMeans.bind(this),
                        this.applyBonus.bind(this),
                        this.props.data.settings?.["easychaw"],
                      ),
                    ) +
                    Math.ceil(
                      serviceCharge(
                        this.props.cart,
                        this.props.data.products,
                        this.props.data.merchants,
                        this.state.postDatedOrders,
                        {
                          percentageOrdersBelowAThousand:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? this.props.data.settings["easychaw"]
                                  .percentageOrdersBelowAThousand
                              : 2.55,
                          percentageOrdersAboveAThousand:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? this.props.data.settings["easychaw"]
                                  .percentageOrdersAboveAThousand
                              : 3.95,
                        },
                        this.deliveryInclusive.bind(this),
                        this.checkDeliveryMeans.bind(this),
                        this.state.easychawWallet,
                        this.props.data.settings?.["easychaw"],
                      ),
                    )
                  }`,
                ),
            },
          },
        };

        const amount =
          this.props.data.products &&
          Number(
            `${
              Math.ceil(
                totalProductAndDeliveryCharge(
                  this.props.cart,
                  this.props.data.products,
                  this.props.data.merchants,
                  this.state.postDatedOrders,
                  this.deliveryInclusive.bind(this),
                  this.checkDeliveryMeans.bind(this),
                  this.applyBonus.bind(this),
                  this.props.data.settings?.["easychaw"],
                ),
              ) +
              Math.ceil(
                serviceCharge(
                  this.props.cart,
                  this.props.data.products,
                  this.props.data.merchants,
                  this.state.postDatedOrders,
                  {
                    percentageOrdersBelowAThousand:
                      this.props.data.settings &&
                      this.props.data.settings["easychaw"]
                        ? this.props.data.settings["easychaw"]
                            .percentageOrdersBelowAThousand
                        : 2.55,
                    percentageOrdersAboveAThousand:
                      this.props.data.settings &&
                      this.props.data.settings["easychaw"]
                        ? this.props.data.settings["easychaw"]
                            .percentageOrdersAboveAThousand
                        : 3.95,
                  },
                  this.deliveryInclusive.bind(this),
                  this.checkDeliveryMeans.bind(this),
                  this.state.easychawWallet,
                  this.props.data.settings?.["easychaw"],
                ),
              )
            }`,
          ) * 100;

        chargeCard(
          idToken,
          this.props.auth.uid,
          authorizationCode,
          amount,
          email,
          this.state.reference,
          metadata,
          (error, message) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            // order placed
            localStorage.removeItem("cart");
            this.props.dispatch({ type: CART, payload: null });

            // redirect to discover page
            this.$f7.views.main.router.navigate("/discover/");

            // clear cart
            setTimeout(() => {
              //   ask user if they want to see history
              this.$f7.preloader.hide();
              this.openHistory(message);
            }, 1000);
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: error,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  // Pay with wallet
  payWithEasychawWallet(coveredByBonus = false) {
    this.$f7.preloader.show();
    // relationship id
    const relId = generateId(7);
    const timestamp = Date.now();
    const reference = this.reference();

    const amount =
      this.props.data.products &&
      Number(
        `${
          Math.ceil(
            totalProductAndDeliveryCharge(
              this.props.cart,
              this.props.data.products,
              this.props.data.merchants,
              this.state.postDatedOrders,
              this.deliveryInclusive.bind(this),
              this.checkDeliveryMeans.bind(this),
              this.applyBonus.bind(this),
              this.props.data.settings?.["easychaw"],
            ),
          ) +
          Math.ceil(
            serviceCharge(
              this.props.cart,
              this.props.data.products,
              this.props.data.merchants,
              this.state.postDatedOrders,
              {
                percentageOrdersBelowAThousand:
                  this.props.data.settings &&
                  this.props.data.settings["easychaw"]
                    ? this.props.data.settings["easychaw"]
                        .percentageOrdersBelowAThousand
                    : 2.55,
                percentageOrdersAboveAThousand:
                  this.props.data.settings &&
                  this.props.data.settings["easychaw"]
                    ? this.props.data.settings["easychaw"]
                        .percentageOrdersAboveAThousand
                    : 3.95,
              },
              this.deliveryInclusive.bind(this),
              this.checkDeliveryMeans.bind(this),
              this.state.easychawWallet,
              this.props.data.settings?.["easychaw"],
            ),
          )
        }`,
      );

    if (Number(amount) <= 0) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Error placing order. Please try again or contact us at support@easychaw.com",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // communitcate to server
    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((token) => {
        const transObj = {
          doc: reference,
          body: {
            walletId: this.props.profile.walletId,
            name: this.props.profile.fullName,
            timestamp,
            relId,
            coveredByBonus,
            useBonus: this.state.useBonus,
            bonus: this.state.bonus,
            status: "Success",
            type: "Received",
            by: "Easychaw",
            from: "Easychaw Wallet",
            // This is service charge and no longer paystack charge. i didn't change it cos it will break alot of things
            paystackCharge:
              this.props.data.products &&
              Number(
                Math.ceil(
                  serviceCharge(
                    this.props.cart,
                    this.props.data.products,
                    this.props.data.merchants,
                    this.state.postDatedOrders,
                    {
                      percentageOrdersBelowAThousand:
                        this.props.data.settings &&
                        this.props.data.settings["easychaw"]
                          ? this.props.data.settings["easychaw"]
                              .percentageOrdersBelowAThousand
                          : 2.55,
                      percentageOrdersAboveAThousand:
                        this.props.data.settings &&
                        this.props.data.settings["easychaw"]
                          ? this.props.data.settings["easychaw"]
                              .percentageOrdersAboveAThousand
                          : 3.95,
                    },
                    this.deliveryInclusive.bind(this),
                    this.checkDeliveryMeans.bind(this),
                    this.state.easychawWallet,
                    this.props.data.settings?.["easychaw"],
                  ),
                ),
              ),
            amount,
          },
          orders: this.props.cart.map((cartObject) => {
            let packages = cartObject.packages.map((product) => ({
              ...product,
              preparationTime:
                this.props.data.products[product.productId].preparationTime,
              name: this.props.data.products[product.productId].name,
              discount: this.props.data.products[product.productId].discount,
              amount:
                this.props.data.products[product.productId].discount === "" ||
                +this.props.data.products[product.productId].discount < 1
                  ? +(
                      Number(product.count) *
                      +this.props.data.products[product.productId].price
                    ).toFixed(2)
                  : +(
                      +product.count *
                      (+this.props.data.products[product.productId].price -
                        (+this.props.data.products[product.productId].discount /
                          100) *
                          +this.props.data.products[product.productId].price)
                    ).toFixed(2),

              merchantAmount:
                this.props.data.products[product.productId].discount === "" ||
                +this.props.data.products[product.productId].discount < 1
                  ? +(
                      Number(product.count) *
                      (+this.props.data.products[product.productId].price -
                        ((this.props.data.settings?.easychaw?.promo?.[
                          cartObject.merchantId
                        ]?.commissionOnSales || 3.5) /
                          100) *
                          +this.props.data.products[product.productId].price)
                    ).toFixed(2)
                  : +(
                      Number(product.count) *
                      (+this.props.data.products[product.productId].price -
                        (+this.props.data.products[product.productId].discount /
                          100) *
                          +this.props.data.products[product.productId].price -
                        ((this.props.data.settings?.easychaw?.promo?.[
                          cartObject.merchantId
                        ]?.commissionOnSales || 3.5) /
                          100) *
                          (+this.props.data.products[product.productId].price -
                            (+this.props.data.products[product.productId]
                              .discount /
                              100) *
                              +this.props.data.products[product.productId]
                                .price))
                    ).toFixed(2),
              userAmount: Math.ceil(
                Number(product.count) *
                  Number(
                    totalProductPrice(
                      this.props.data.products[product.productId].price,
                      this.props.data.products[product.productId].discount,
                    ),
                  ),
              ),
            }));

            return {
              ...cartObject,
              packages: [...packages],
              timestamp,
              completed: false,
              orderStatus: "Order Pending",
              qualifiedForEasychawBonus: userQualifiedForEasychawDiscount(
                this.props.cart,
                this.props.data.products,
              )
                ? true
                : false,
              deliveryRequired: checkFreeDelivery(
                packages,
                this.props.data.products,
              )
                ? false
                : true, // NOTE: Is this gonna be provided by the user?
              expectedDeliveryTime:
                this.state.expectedDeliveryTime[cartObject.merchantId] &&
                this.state.expectedDeliveryTime[cartObject.merchantId].time,
              postDatedDate:
                this.state.postDatedOrders[cartObject.merchantId] &&
                this.state.postDatedOrders[cartObject.merchantId].postDatedDate
                  ? this.state.postDatedOrders[cartObject.merchantId]
                      .postDatedDate
                  : null,
              postDatedInstructions:
                this.state.postDatedOrders[cartObject.merchantId] &&
                this.state.postDatedOrders[cartObject.merchantId]
                  .postDatedInstructions
                  ? this.state.postDatedOrders[cartObject.merchantId]
                      .postDatedInstructions
                  : null,
              deliveryAddress:
                this.state.postDatedOrders[cartObject.merchantId] &&
                this.state.postDatedOrders[cartObject.merchantId]
                  .deliveryAddress,
              geoLoc: this.state.postDatedOrders[cartObject.merchantId] && {
                ...this.state.postDatedOrders[cartObject.merchantId].geoLoc,
              },
              fullName: this.props.profile.fullName,
              phoneNumber: this.props.profile.phoneNumber
                ? this.props.profile.phoneNumber
                : "",
              email: this.props.profile.email,
              userId: this.props.auth.uid,
              relId,
              reference,
              distanceFromMerchant: Math.ceil(
                getDistance(
                  this.props.data.merchants[cartObject.merchantId]
                    .businessProfile.geoLoc,
                  this.state.postDatedOrders[cartObject.merchantId].geoLoc,
                ) / 1000,
              ),
              confirmationCode: cryptoRandomString({
                length: 6,
                type: "numeric",
              }),

              deliveryAgentDeliveryCharge: checkFreeDelivery(
                packages,
                this.props.data.products,
              )
                ? 0
                : +(
                    deliveryCharge(
                      this.props.data.merchants[cartObject.merchantId]
                        .businessProfile.geoLoc,
                      this.state.postDatedOrders[cartObject.merchantId].geoLoc,
                      {
                        defaultDeliveryCharge:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                cartObject,
                              )?.deliveryCharge ||
                                this.props.data.settings["easychaw"]
                                  .defaultDeliveryCharge) *
                              this.checkDeliveryMeans(packages)
                            : 500,
                        perKmDeliveryCharge:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                cartObject,
                              )?.kmPerDeliveryCharge ||
                                this.props.data.settings["easychaw"]
                                  .perKmDeliveryCharge) *
                              this.checkDeliveryMeans(packages)
                            : 50,
                      },
                      this.deliveryInclusive(packages),
                    ) -
                    (3.5 / 100) *
                      deliveryCharge(
                        this.props.data.merchants[cartObject.merchantId]
                          .businessProfile.geoLoc,
                        this.state.postDatedOrders[cartObject.merchantId]
                          .geoLoc,
                        {
                          defaultDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.deliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .defaultDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 500,
                          perKmDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.kmPerDeliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .perKmDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 50,
                        },
                        this.deliveryInclusive(packages),
                      )
                  ).toFixed(2),
              userDeliveryCharge: checkFreeDelivery(
                packages,
                this.props.data.products,
              )
                ? 0
                : Math.ceil(
                    deliveryCharge(
                      this.props.data.merchants[cartObject.merchantId]
                        .businessProfile.geoLoc,
                      this.state.postDatedOrders[cartObject.merchantId].geoLoc,
                      {
                        defaultDeliveryCharge:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                cartObject,
                              )?.deliveryCharge ||
                                this.props.data.settings["easychaw"]
                                  .defaultDeliveryCharge) *
                              this.checkDeliveryMeans(packages)
                            : 500,
                        perKmDeliveryCharge:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                cartObject,
                              )?.kmPerDeliveryCharge ||
                                this.props.data.settings["easychaw"]
                                  .perKmDeliveryCharge) *
                              this.checkDeliveryMeans(packages)
                            : 50,
                      },
                      this.deliveryInclusive(packages),
                    ),
                  ),
              deliveryInclusive: this.deliveryInclusive(packages).inclusive,
              commissionFreeSales:
                this.props.data.settings?.easychaw?.promo?.[
                  cartObject.merchantId
                ]?.commissionFreeSales ??
                this.props.data.settings?.easychaw?.defaultCommissionFreeSales,
              commissionOnSales:
                this.props.data.settings?.easychaw?.promo?.[
                  cartObject.merchantId
                ]?.commissionOnSales ?? 3.5,
              totalAmount: !this.deliveryInclusive(packages).inclusive
                ? packages
                    .map((p) => p.amount)
                    .reduce((a, b) => Number(a) + Number(b), 0)
                : packages
                    .map((p) => p.amount)
                    .reduce((a, b) => Number(a) + Number(b), 0) +
                  (checkFreeDelivery(packages, this.props.data.products)
                    ? 0
                    : +deliveryCharge(
                        this.props.data.merchants[cartObject.merchantId]
                          .businessProfile.geoLoc,
                        this.state.postDatedOrders[cartObject.merchantId]
                          .geoLoc,
                        {
                          defaultDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.deliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .defaultDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 500,
                          perKmDeliveryCharge:
                            this.props.data.settings &&
                            this.props.data.settings["easychaw"]
                              ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                  cartObject,
                                )?.kmPerDeliveryCharge ||
                                  this.props.data.settings["easychaw"]
                                    .perKmDeliveryCharge) *
                                this.checkDeliveryMeans(packages)
                              : 50,
                        },
                        this.deliveryInclusive(packages),
                      ).toFixed(2)),
              totalMerchantAmount: !this.deliveryInclusive(packages).inclusive
                ? packages
                    .map((p) => p.merchantAmount)
                    .reduce((a, b) => Number(a) + Number(b), 0)
                : packages
                    .map((p) => p.merchantAmount)
                    .reduce((a, b) => Number(a) + Number(b), 0) +
                  (checkFreeDelivery(packages, this.props.data.products)
                    ? 0
                    : +(
                        deliveryCharge(
                          this.props.data.merchants[cartObject.merchantId]
                            .businessProfile.geoLoc,
                          this.state.postDatedOrders[cartObject.merchantId]
                            .geoLoc,
                          {
                            defaultDeliveryCharge:
                              this.props.data.settings &&
                              this.props.data.settings["easychaw"]
                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                    cartObject,
                                  )?.deliveryCharge ||
                                    this.props.data.settings["easychaw"]
                                      .defaultDeliveryCharge) *
                                  this.checkDeliveryMeans(packages)
                                : 500,
                            perKmDeliveryCharge:
                              this.props.data.settings &&
                              this.props.data.settings["easychaw"]
                                ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                    cartObject,
                                  )?.kmPerDeliveryCharge ||
                                    this.props.data.settings["easychaw"]
                                      .perKmDeliveryCharge) *
                                  this.checkDeliveryMeans(packages)
                                : 50,
                          },
                          this.deliveryInclusive(packages),
                        ) -
                        ((this.props.data.settings?.easychaw?.promo?.[
                          cartObject.merchantId
                        ]?.commissionOnSales ?? 3.5) /
                          100) *
                          deliveryCharge(
                            this.props.data.merchants[cartObject.merchantId]
                              .businessProfile.geoLoc,
                            this.state.postDatedOrders[cartObject.merchantId]
                              .geoLoc,
                            {
                              defaultDeliveryCharge:
                                this.props.data.settings &&
                                this.props.data.settings["easychaw"]
                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                      cartObject,
                                    )?.deliveryCharge ||
                                      this.props.data.settings["easychaw"]
                                        .defaultDeliveryCharge) *
                                    this.checkDeliveryMeans(packages)
                                  : 500,
                              perKmDeliveryCharge:
                                this.props.data.settings &&
                                this.props.data.settings["easychaw"]
                                  ? (this.getMerchantCityDefaultDeliveryKmCharges(
                                      cartObject,
                                    )?.kmPerDeliveryCharge ||
                                      this.props.data.settings["easychaw"]
                                        .perKmDeliveryCharge) *
                                    this.checkDeliveryMeans(packages)
                                  : 50,
                            },
                            this.deliveryInclusive(packages),
                          )
                      ).toFixed(2)),
              totalUserAmount: packages
                .map((p) => p.userAmount)
                .reduce((a, b) => Number(a) + Number(b), 0),
              serviceCharge:
                this.props.data.products &&
                Number(
                  Math.ceil(
                    serviceCharge(
                      this.props.cart,
                      this.props.data.products,
                      this.props.data.merchants,
                      this.state.postDatedOrders,
                      {
                        percentageOrdersBelowAThousand:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? this.props.data.settings["easychaw"]
                                .percentageOrdersBelowAThousand
                            : 2.55,
                        percentageOrdersAboveAThousand:
                          this.props.data.settings &&
                          this.props.data.settings["easychaw"]
                            ? this.props.data.settings["easychaw"]
                                .percentageOrdersAboveAThousand
                            : 3.95,
                      },
                      this.deliveryInclusive.bind(this),
                      this.checkDeliveryMeans.bind(this),
                      this.state.easychawWallet,
                      this.props.data.settings?.["easychaw"],
                    ),
                  ),
                ),
            };
          }),
        };

        // Update transaction DB
        transact(token, this.props.auth.uid, transObj, (err, success) => {
          if (err) {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          }

          // order placed
          localStorage.removeItem("cart");
          this.props.dispatch({ type: CART, payload: null });

          // redirect to discover page
          this.$f7.views.main.router.navigate("/discover/");

          // clear cart
          setTimeout(() => {
            //   ask user if they want to see history
            this.openHistory("Approved");
          }, 1000);
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Error placing order. Please try again or contact us at support@easychaw.com",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  sendReport(props, error) {
    let text = "Thank you for sending a report!";

    toast(this.$f7.toast, {
      text,
      position: "bottom",
      horizontalPosition: "center",
      closeButton: true,
      cssClass: "custom-toast",
      closeTimeout: 3000,
    });
  }

  // Sign In
  login() {
    const self = this;
    const app = self.$f7;
    const email = self.state.email;
    const password = self.state.password;

    self.setState({
      ...this.state,
      signInButton: "Signing In, Please wait...",
    });

    this.props.firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(({ user }) => {
        self.setState({ ...this.state, signInButton: "Sign In" });
        this.props.firestore
          .collection("users")
          .doc(user.uid)
          .get()
          .then((profile) => {
            if (profile.data().accountStatus === "Suspended") {
              app.dialog.alert(
                "Your account has been suspended. Contact admin via support@easychaw.com",
              );
              return this.props.firebase.auth().signOut();
            }
            app.loginScreen.close();
          });
      })
      .catch(({ code, message }) => {
        switch (code) {
          case "auth/user-not-found":
            toast(app.toast, {
              text: message,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
            break;
          case "auth/invalid-email":
            toast(app.toast, {
              text: "Invalid Email/Password",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            break;
          case "auth/wrong-password":
            toast(app.toast, {
              text: "Invalid Email/Password",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            break;
          default:
            toast(app.toast, {
              text: "Something went wrong",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
        }
        self.setState({ ...this.state, signInButton: "Sign In" });
      });
  }

  // Register
  register() {
    this.setState({
      ...this.state,
      registerButton: "Signing Up, Please Wait...",
    });
    const self = this;
    const app = self.$f7;

    let fullName = self.state.fullName;
    let phone = self.state.phoneNumber;
    let email = self.state.email;
    let password = self.state.password;

    // Validate fullname
    if (fullName.trim() === "") {
      toast(app.toast, {
        text: "Please fill out the fullname field",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });

      return this.setState({ ...this.state, registerButton: "Sign Up" });
    }

    if (phone.trim() === "") {
      toast(app.toast, {
        text: "Please fill out the phone number field",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });

      return this.setState({ ...this.state, registerButton: "Sign Up" });
    }

    if (phone.trim().length !== 11) {
      toast(app.toast, {
        text: "Please provide a valid phone number",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });

      return this.setState({ ...this.state, registerButton: "Sign Up" });
    }

    isAllowed(
      {
        token: "",
        uid: "",
        details: { collection: "users", property: "phoneNumber", value: phone },
      },
      (error, success) => {
        if (error) {
          this.setState({
            ...this.state,
            registerButton: "Sign Up",
          });
          return toast(this.$f7.toast, {
            text: error,
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        }

        this.props.firebase
          .auth()
          .createUserWithEmailAndPassword(email, password)
          .then(({ user }) => {
            const walletId = generateId(7);

            this.props.firestore
              .collection("users")
              .doc(user.uid)
              .set({
                email,
                fullName,
                phoneNumber: phone,
                role: "Basic",
                accountStatus: "Approved",
                lastUpdated: Date.now(),
                walletId,
              })
              .then((doc) => {
                this.setState({
                  ...this.state,
                  registerButton: "Sign Up",
                  fullName: "",
                  phoneNumber: "",
                  email: "",
                  password: "",
                });
                app.loginScreen.close();
              })
              .catch((error) => {
                this.setState({
                  ...this.state,
                  registerButton: "Sign Up",
                });
                return toast(app.toast, {
                  text: handleErrors(error),
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              });

            //sign user out and switch to sign in
            // this.props.firebase
            //   .auth()
            //   .signOut()
            //   .then(() => {
            //     let text = 'Account created successfully, please sign in.';
            //     toast(app.toast, {
            //       text,
            //       position: 'bottom',
            //       horizontalPosition: 'center',
            //       closeButton: true,
            //       cssClass: 'custom-toast',
            //       closeTimeout: 7000,
            //     });
            //     this.setState({
            //       ...this.state,
            //       register: false,
            //     });
            //   })
            //   .catch((error) => {
            //     return toast(app.toast, {
            //       text: handleErrors(error),
            //       position: 'bottom',
            //       horizontalPosition: 'center',
            //       closeButton: true,
            //       cssClass: 'custom-toast',
            //       closeTimeout: 4000,
            //     });
            //   });
          })
          .catch(({ code, message }) => {
            switch (code) {
              case "auth/email-already-in-use":
                toast(app.toast, {
                  text: message,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });

                break;
              case "auth/invalid-email":
                toast(app.toast, {
                  text: "Invalid Email Address",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });

                break;
              case "auth/weak-password":
                toast(app.toast, {
                  text: message,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });

                break;
              default:
                toast(app.toast, {
                  text: "Something went wrong",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
            }

            this.setState({
              ...this.state,
              registerButton: "Sign Up",
            });
          });
      },
    );
  }

  openHistory(res) {
    const self = this.$f7;
    self.preloader.hide();
    self.dialog
      .create({
        title: res,
        cssClass: "otp-code-modal",
        text: "Order is been processed. Check your order history for order status.",
        buttons: [
          // button to close
          {
            text: "Later",
            color: "gray",
            cssClass: "otp-resend",
            onClick: (dialog, e) => {},
          },

          // button to open history
          {
            text: "Track Order",
            bold: true,
            cssClass: "otp-continue",
            keyCodes: [13],
            onClick: (dialog, e) => {
              self.tab.show(`#view-account`, false);
              self.methods.navAccount("profile");
              self.views.account.router.navigate("/profile/1/");
            },
          },
        ],
        destroyOnClose: true,
      })
      .open();
  }

  callback(response) {
    if (response.status === "success") {
      // Place orders

      // order placed
      // clear cart
      localStorage.removeItem("cart");
      this.props.dispatch({ type: CART, payload: null });

      // redirect to discover page
      this.$f7.views.main.router.navigate("/discover/");

      setTimeout(() => {
        //   ask user if they want to see history
        this.openHistory("Approved");
      }, 1000);
    } else {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: response.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  reference() {
    return this.state.reference;
  }

  close() {}

  blurWithEmptyness(e, cartObject, p) {
    if (e.target.value === "") {
      this.setState({
        ...this.state,
        cart: this.state.cart.map((co) => {
          if (co.merchantId === cartObject.merchantId) {
            return {
              ...co,
              packages: co.packages.map((o) => {
                if (o.productId === p.productId) {
                  return {
                    ...o,
                    count: p.count,
                  };
                } else {
                  return o;
                }
              }),
            };
          } else {
            return co;
          }
        }),
      });
    }
  }

  changeCount(count, merchantId, productId) {
    // Check if the user is no authenticated and change localstorage

    if (count !== "") {
      let cart = [...this.state.cart];

      let index;
      let pIndex;

      cart.forEach((c, i) => {
        if (c.merchantId === merchantId) {
          index = i;
          c.packages.forEach((o, j) => {
            if (o.productId === productId) {
              pIndex = j;
            }
          });
        }
      });

      cart[index].packages[pIndex].count =
        parseInt(count) === "NaN"
          ? count
          : parseInt(count) === 0
          ? 1
          : this.props.ordered.products.find(
              (product) => product.id === productId,
            ) &&
            this.props.ordered.products.find(
              (product) => product.id === productId,
            ).stocked !== "" &&
            parseInt(count) >
              parseInt(
                this.props.ordered.products.find(
                  (product) => product.id === productId,
                ).stocked,
              )
          ? this.props.ordered.products.find(
              (product) => product.id === productId,
            ).stocked
          : parseInt(count);

      // if (this.props.auth.isEmpty) {
      // update cart
      localStorage.setItem("cart", JSON.stringify(cart));
      this.props.dispatch({ type: CART, payload: cart });
      // }
    }
  }

  delayChangeCount(e, cartObject, p, callback) {
    this.setState({
      ...this.state,
      cart: this.state.cart.map((co) => {
        if (co.merchantId === cartObject.merchantId) {
          return {
            ...co,
            packages: co.packages.map((o) => {
              if (o.productId === p.productId) {
                return {
                  ...o,
                  count:
                    typeof parseInt(o.count) === "number" &&
                    e.target.value == ""
                      ? e.target.value
                      : o.count === "" && parseInt(e.target.value) === 0
                      ? 1
                      : this.props.ordered.products.find(
                          (product) => product.id === p.productId,
                        ) &&
                        this.props.ordered.products.find(
                          (product) => product.id === p.productId,
                        ).stocked !== "" &&
                        parseInt(e.target.value) >
                          parseInt(
                            this.props.ordered.products.find(
                              (product) => product.id === p.productId,
                            ).stocked,
                          )
                      ? this.props.ordered.products.find(
                          (product) => product.id === p.productId,
                        ).stocked
                      : e.target.value,
                };
              } else {
                return o;
              }
            }),
          };
        } else {
          return co;
        }
      }),
    });

    callback(e.target.value, cartObject.merchantId, p.productId);
  }

  removeCartItem(merchantId, productId) {
    let cart = [...this.props.cart];
    cart = cart.map((cartObject) => {
      if (cartObject.merchantId !== merchantId) {
        return cartObject;
      } else {
        cartObject.packages = cartObject.packages.filter(
          (p) => p.productId !== productId,
        );

        return cartObject;
      }
    });

    cart = cart.filter((cartObject) => cartObject.packages.length !== 0);

    // set postdated orders state
    const postDatedOrders = {};

    if (cart.length === 0) {
      localStorage.removeItem("cart");
      this.props.dispatch({ type: CART, payload: null });
      this.setState({
        ...this.state,
        cart: null,
        postDatedOrders,
      });
    } else {
      cart.forEach((cartObject) => {
        postDatedOrders[cartObject.merchantId] = {
          ...this.state.postDatedOrders[cartObject.merchantId],
        };
      });

      localStorage.setItem("cart", JSON.stringify(cart));
      this.props.dispatch({ type: CART, payload: cart });
      this.setState({
        ...this.state,
        cart,
        postDatedOrders,
      });
    }
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { ordered, data, docs },
  discover,
  cart,
}) => ({
  auth,
  profile,
  ordered,
  docs,
  data,
  cart,
  discover,
});

const enhance = compose(
  firestoreConnect((props) => [
    new Collections("products"),
    new Collections("merchants"),
    new Collections("settings"),
    new Doc("wallets", (props.auth && props.userWalletId) || null),
  ]),
  connect(mapStateToProps),
);

export default enhance(Cart);
